import { Tab, TabList, TabPanel } from '@welm/react-tabs';
import { Tabs } from 'antd';
import jsPDF from 'jspdf';
import { useCallback, useEffect, useRef, useState } from 'react';
import { BiMinusCircle, BiPlusCircle } from 'react-icons/bi';
import { v4 as uuidv4 } from 'uuid';
import { useSystemContext } from '../../Context/SystemContext';
import Chart84 from '../../components/Chart84';
import Grid from '../../components/Grid';
import { Grid5W2H } from '../../components/Grid5W2H';
import { GridAnexos } from '../../components/GridAnexos';
import { GridDiario } from '../../components/GridDiario';
import {
    AttachmentInput,
    CepInput,
    CheckBoxInput,
    DBSelectInput,
    DateInputBR,
    DropDownGroupInput,
    FormInput,
    GroupInput,
    Input,
    MaskInput,
    SelectInput,
    TabsInput,
    TextInput,
    TimeInput
} from '../../components/Input';
import { normalizeText } from '../../helper/Text';
import { dateToString } from '../../helper/dates';



const yup = require('../../interface/yup-br');

export const Form81 = () => {
    const System = useSystemContext();
    return (
        <div>
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form81"
                        perms={'81'}
                        title={System.getMenuTitle(81)}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url="/attachment/form81" perms="81" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form811 = () => {
    const System = useSystemContext();
    return (
        <div>
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form811"
                        perms={'811'}
                        title={System.getMenuTitle(811)}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url="/attachment/form811" perms="811" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};

export const Form812 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form812"
                perms={'812'}
                title={System.getMenuTitle(812)}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form813 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form813"
                perms={'813'}
                title={System.getMenuTitle(813)}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form814 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form814"
                perms={'814'}
                title={System.getMenuTitle(814)}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form82 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form82"
                perms={'82'}
                title={System.getMenuTitle(82)}
                initialValues={{
                    conteudo: '',
                }}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form82SGI = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form82"
                        perms={'82'}
                        title={System.getMenuTitle(82)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Preparação e Resposta de Emergência">
                    <div className="w-full h-80">
                        <Grid
                            url={'/griddocument/grid82'}
                            perms={'82001'}
                            clearAutoEdit={true}
                            GridHeaders={[
                                { title: 'Tipo', field: 'tipo', sort: true, className: 'w-1/6 text-left pl-1 border-l border-gray-300' },
                                { title: 'Data', field: 'data', sort: true, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                { title: 'Local', field: 'local', sort: true, className: 'w-2/6 pl-1 text-left border-l border-gray-300' },
                                { title: 'Responsável', field: 'responsavel', sort: false, className: 'w-2/6 pl-1 text-left border-l border-gray-300' },
                            ]}
                            LineDataPrint={(data) => {
                                return [data.tipo, dateToString(data.data), data.local, data.crew?.nome];
                            }}
                            onRenderForm={(GridModes, SetFieldValue, values) => {
                                return (
                                    <div>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                        </div>

                                        <GroupInput>
                                            <SelectInput name="tipo" label="Tipo" className="w-full" listOptions={[{ value: 'Simulado' }, { value: 'Ocorrência' }]} />
                                            <DateInputBR name="data" label="Data" />
                                            <TimeInput type="time" name="inicio" label="Horário Inicio" />
                                            <TimeInput type="time" name="final" label="Horário Fim" />
                                        </GroupInput>
                                        <Input name="local" label="Local" />
                                        <TextInput name="participantes" label="Participantes" className="w-full" rows="8" />
                                        <TextInput name="cenario" label="Cenário (Descrição do Ocorrido)" className="w-full" rows="8" />
                                        <TextInput name="positivos" label="Pontos Positivos" className="w-full" rows="8" />
                                        <TextInput name="melhoria" label="Oportunidades de Melhoria" className="w-full" rows="8" />
                                        <DBSelectInput name="responsavel" label="Responsável" url={GridModes.insert_mode ? '/crewactive' : '/crew'} displaySelectField="nome" />
                                    </div>
                                );
                            }}
                            validationSchema={yup.object().shape({
                                tipo: yup.string(),
                                data: yup.date(),
                                local: yup.string(),
                                participantes: yup.string(),
                                cenario: yup.string(),
                                positivos: yup.string(),
                                melhoria: yup.string(),
                            })}
                            FormTabs={[
                                () => {
                                    return <div>Home</div>;
                                },
                                () => {
                                    return <div>5W2H</div>;
                                },
                                () => {
                                    return <div>Diário de Bordo</div>;
                                },
                                () => {
                                    return <div>Anexos</div>;
                                },
                            ]}
                            onRenderFormExtra={[
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div className={'m-2'}>
                                            <Grid5W2H url={`/method5w2h/form82001-${item._id}`} perms="82001" />
                                        </div>
                                    );
                                },
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div>
                                            {!GridModes.insert_mode && (
                                                <div className={'m-2'}>
                                                    <GridDiario url={'/griddocument/grid82-' + item._id} perms={'82001'} />
                                                </div>
                                            )}
                                        </div>
                                    );
                                },
                                (GridModes, item, GridRefresh) => {
                                    // Anexos
                                    return (
                                        <div className={'m-2'}>
                                            <GridAnexos url={`/attachment/form82001-${item._id}`} disableModal={true} perms="82001" />
                                        </div>
                                    );
                                },
                            ]}
                            onBeforeDelete={async (item) => {
                                await System.apiDelete('/griddocument/grid82001-' + item._id);
                                await System.apiDelete(`/attachment/form82001-${item._id}`);
                            }}
                        />
                    </div>
                </TabPanel>
                <TabPanel>
                    <GridAnexos url="/attachment/form82001" perms="82001" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form821 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form821"
                        perms={'821'}
                        title={System.getMenuTitle(821)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel>
                    <GridAnexos url="/attachment/form821" perms="821" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form822 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form822"
                perms={'822'}
                title={System.getMenuTitle(822)}
                initialValues={{
                    conteudo: '',
                }}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form823 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form823"
                        perms={'823'}
                        title={System.getMenuTitle(823)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel>
                    <GridAnexos url="/attachment/form823" perms="823" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form824 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form824"
                        perms={'824'}
                        title={System.getMenuTitle(824)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url={'/attachment/form824'} perms="824" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form83 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form83"
                        perms={'83'}
                        title={System.getMenuTitle(83)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Gestão">
                    <Grid
                        url={'/griddocument/grid83'}
                        perms={'83'}
                        clearAutoEdit={true}
                        GridHeaders={[
                            { title: 'Código', field: 'codigo', sort: true, className: 'w-1/6 text-left pl-1' },
                            { title: 'Título', field: 'titulo', sort: true, className: 'w-2/6 pl-1 text-left border-l border-gray-300' },
                            { title: 'De', field: 'de', sort: true, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                            { title: 'Até', field: 'ate', sort: true, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                            { title: 'Responsável', field: 'responsavel', sort: true, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                        ]}
                        LineDataPrint={(data) => {
                            return [data.codigo, data.titulo, dateToString(data.de), dateToString(data.ate), data.crew?.nome];
                        }}
                        onPrepareSaveRecord={(values) => {
                            let newForm = new FormData();
                            for (let key in values) {
                                newForm.append(key, values[key]);
                            }
                            return newForm;
                        }}
                        onRenderForm={(GridModes, setFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <GroupInput>
                                        <Input name="codigo" label="Código" className={'w-1/4'} />
                                        <Input name="titulo" label="Título" />
                                    </GroupInput>
                                    <GroupInput>
                                        <DateInputBR name="de" label="Período de" />
                                        <DateInputBR name="ate" label="Até" />
                                    </GroupInput>
                                    <GroupInput>
                                        <DBSelectInput name="responsavel" label="Responsável" url={GridModes.insert_mode ? '/crewactive' : '/crew'} displaySelectField="nome" />
                                    </GroupInput>
                                    <TextInput name="descricao" label="Descrição" className="w-full" rows="4" />
                                </div>
                            );
                        }}
                        validationSchema={yup.object().shape({
                            codigo: yup.string(),
                            titulo: yup.string(),
                            de: yup.date(),
                            ate: yup.date(),
                            responsavel: yup.string(),
                        })}
                        FormTabs={[
                            () => {
                                return <div>Home</div>;
                            },
                            () => {
                                return <div>Entrada</div>;
                            },
                            () => {
                                return <div>Saída</div>;
                            },
                            () => {
                                return <div>Análise Crítica</div>;
                            },
                            () => {
                                return <div>Verificação</div>;
                            },
                            () => {
                                return <div>Validação</div>;
                            },
                            () => {
                                return <div>Controle de Alterações</div>;
                            },
                            () => {
                                return (
                                    <div className="inline-flex justify-center">
                                        <span>Anexos</span>
                                    </div>
                                );
                            },
                        ]}
                        onRenderFormExtra={[
                            (GridModes, item, GridRefresh) => {
                                // Entrada
                                return (
                                    <div>
                                        <FormInput
                                            document={`/griddocument/grid83/${item._id}`}
                                            perms={'83'}
                                            onRenderFields={(setFieldValue, values) => {
                                                return (
                                                    <div className="w-full">
                                                        <GroupInput>
                                                            <DateInputBR name="entrada_inicio" label="Data Início" className={'inline-block'} />
                                                            <DateInputBR name="entrada_fim" label="Data Final" className={'inline-block'} />
                                                            <DBSelectInput
                                                                name="entrada_responsavel"
                                                                label="Responsável"
                                                                url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                displaySelectField="nome"
                                                            />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <SelectInput
                                                                name="entrada_status"
                                                                label="Status"
                                                                listOptions={[{ value: 'Pendente' }, { value: 'Concluído' }]}
                                                                className={'w-44'}
                                                            />
                                                        </GroupInput>
                                                    </div>
                                                );
                                            }}
                                            onPrepareSaveRecord={(values, sender) => {
                                                // requerido para anexos
                                                let newForm = new FormData();
                                                for (let key in values) {
                                                    newForm.append(key, values[key]);
                                                }
                                                return newForm;
                                            }}
                                            validationSchema={yup.object().shape({
                                                entrada_inicio: yup.date(),
                                                entrada_fim: yup.date(),
                                                entrada_responsavel: yup.string(),
                                                entrada_anexo: yup.string(),
                                                entrada_status: yup.string(),
                                            })}
                                        />
                                        <div className={'m-2'}>
                                            <Grid
                                                url={`/griddocument/grid83-entrada-${item._id}`}
                                                perms={'83'}
                                                disableModal={true}
                                                GridHeaders={[
                                                    { title: 'Requisitos', field: 'requisitos', sort: true, className: 'w-1/2 text-left pl-1' },
                                                    { title: 'Análise Crítica', field: 'analise', sort: true, className: 'w-1/2 pl-1 text-left border-l border-gray-300' },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [data.requisitos, data.analise];
                                                }}
                                                onRenderForm={() => {
                                                    return (
                                                        <div className="w-full">
                                                            <Input name="requisitos" label="Requisitos" />
                                                            <Input name="analise" label="Análise Crítica" />
                                                        </div>
                                                    );
                                                }}
                                                validationSchema={() => {
                                                    return yup.object().shape({
                                                        requisitos: yup.string(),
                                                        analise: yup.string(),
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Saida
                                return (
                                    <div>
                                        <FormInput
                                            document={`/griddocument/grid83/${item._id}`}
                                            perms={'83'}
                                            onRenderFields={() => {
                                                return (
                                                    <div className="w-full">
                                                        <GroupInput>
                                                            <DateInputBR name="saida_inicio" label="Data Início" className={'inline-block'} />
                                                            <DateInputBR name="saida_fim" label="Data Final" className={'inline-block'} />
                                                            <DBSelectInput
                                                                name="saida_responsavel"
                                                                label="Responsável"
                                                                url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                displaySelectField="nome"
                                                            />
                                                        </GroupInput>
                                                        <SelectInput
                                                            name="saida_status"
                                                            label="Status"
                                                            listOptions={[{ value: 'Pendente' }, { value: 'Concluído' }]}
                                                            className={'w-44'}
                                                        />
                                                    </div>
                                                );
                                            }}
                                            validationSchema={yup.object().shape({
                                                saida_inicio: yup.date(),
                                                saida_fim: yup.date(),
                                                saida_responsavel: yup.string(),
                                                saida_status: yup.string(),
                                            })}
                                        />
                                        <div className={'m-2'}>
                                            <Grid
                                                url={`/griddocument/grid83-saida-${item._id}`}
                                                perms={'83'}
                                                disableModal={true}
                                                GridHeaders={[
                                                    { title: 'Requisitos', field: 'requisitos', sort: true, className: 'w-1/2 text-left pl-1' },
                                                    { title: 'Análise Crítica', field: 'analise', sort: true, className: 'w-1/2 pl-1 text-left border-l border-gray-300' },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [data.requisitos, data.analise];
                                                }}
                                                onRenderForm={() => {
                                                    return (
                                                        <div className="w-full">
                                                            <Input name="requisitos" label="Requisitos" />
                                                            <Input name="analise" label="Análise Crítica" />
                                                        </div>
                                                    );
                                                }}
                                                validationSchema={() => {
                                                    return yup.object().shape({
                                                        requisitos: yup.string(),
                                                        analise: yup.string(),
                                                    });
                                                }}
                                            />
                                        </div>
                                    </div>
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Análise Crítica
                                var url = `/griddocument/grid83-analise-${item._id}`;
                                return (
                                    <div className={'m-2'}>
                                        <Grid
                                            url={url}
                                            perms={'83'}
                                            disableModal={true}
                                            GridHeaders={[
                                                { title: 'Inicio', field: 'inicio', sort: true, className: 'w-1/12 text-left pl-1' },
                                                { title: 'Fim', field: 'fim', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                { title: 'Titulo', field: 'titulo', sort: true, className: 'w-7/12 pl-1 text-left border-l border-gray-300' },
                                                { title: 'Status', field: 'status', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                { title: 'Responsável', field: 'reponsavel', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                            ]}
                                            LineDataPrint={(data) => {
                                                return [dateToString(data.inicio), dateToString(data.fim), data.titulo, data.status, data.crew?.nome];
                                            }}
                                            onRenderForm={() => {
                                                return (
                                                    <div className="w-full">
                                                        <GroupInput>
                                                            <DateInputBR name="inicio" label="Início" />
                                                            <DateInputBR name="fim" label="Fim" />
                                                            <Input name="titulo" label="Titulo" />
                                                        </GroupInput>
                                                        <TextInput name="descricao" label="Descrição" />
                                                        <GroupInput>
                                                            <SelectInput
                                                                name="status"
                                                                label="Status"
                                                                className={'w-36'}
                                                                listOptions={[{ value: 'Pendente' }, { value: 'Concluído' }]}
                                                            />
                                                            <DBSelectInput
                                                                name="responsavel"
                                                                label="Responsável"
                                                                url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                displaySelectField="nome"
                                                            />
                                                        </GroupInput>
                                                    </div>
                                                );
                                            }}
                                            validationSchema={() => {
                                                return yup.object().shape({
                                                    requisitos: yup.string(),
                                                    analize: yup.string(),
                                                    status: yup.string(),
                                                });
                                            }}
                                            FormTabs={[
                                                () => {
                                                    return <div>Home</div>;
                                                },
                                                () => {
                                                    return <div>Presença</div>;
                                                },
                                                () => {
                                                    return <div>Anexo</div>;
                                                },
                                            ]}
                                            onRenderFormExtra={[
                                                (GridModes, subitem, GridRefresh) => {
                                                    // presença
                                                    return (
                                                        <Grid
                                                            url={`/griddocument/grid83-analise-presenca-${subitem._id}`}
                                                            perms={'83'}
                                                            disableModal={true}
                                                            GridHeaders={[
                                                                { title: 'Nome', field: 'nome', sort: true, className: 'w-1/3 text-left pl-1' },
                                                                { title: 'Presença', field: 'presenca', sort: true, className: 'w-1/5 pl-1 text-left border-l border-gray-300' },
                                                                {
                                                                    title: 'Justificativa',
                                                                    field: 'justificativa',
                                                                    sort: true,
                                                                    className: 'w-1/2 pl-1 text-left border-l border-gray-300',
                                                                },
                                                            ]}
                                                            LineDataPrint={(data) => {
                                                                return [data.nome, data.presenca ? 'Sim' : 'Não', data.justificativa];
                                                            }}
                                                            onRenderForm={() => {
                                                                return (
                                                                    <div className="w-full">
                                                                        <GroupInput>
                                                                            <Input name="nome" label="Nome" />
                                                                            <CheckBoxInput name="presenca" label="Presença" />
                                                                        </GroupInput>
                                                                        <Input name="justificativa" label="Justificativa" />
                                                                    </div>
                                                                );
                                                            }}
                                                            validationSchema={() => {
                                                                return yup.object().shape({
                                                                    nome: yup.string(),
                                                                    presenca: yup.boolean(),
                                                                    justificativa: yup.string(),
                                                                });
                                                            }}
                                                        />
                                                    );
                                                },
                                                (GridModes, subitem, GridRefresh) => {
                                                    // anexo
                                                    return (
                                                        <FormInput
                                                            document={`${url}/${subitem._id}`}
                                                            perms={'83'}
                                                            onPrepareSaveRecord={(values, sender) => {
                                                                let newForm = new FormData();
                                                                for (let key in values) {
                                                                    newForm.append(key, values[key]);
                                                                }
                                                                return newForm;
                                                            }}
                                                            validationSchema={yup.object().shape({
                                                                arquivo: yup.string(),
                                                            })}
                                                            onAfterSave={() => {
                                                                GridRefresh();
                                                            }}
                                                            onRenderFields={(setFieldValue, values, callCommit) => {
                                                                return <AttachmentInput name="attachment" perms={'83'} label="Anexo" callParentCommit={callCommit} />;
                                                            }}
                                                        />
                                                    );
                                                },
                                            ]}
                                        />
                                    </div>
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Verificação
                                return (
                                    <FormInput
                                        document={`/griddocument/grid83/${item._id}`}
                                        perms={'83'}
                                        onRenderFields={() => {
                                            return (
                                                <div className="w-full">
                                                    <GroupInput>
                                                        <DateInputBR name="verificacao_inicio" label="Data Início" className={'inline-block'} />
                                                        <DateInputBR name="verificacao_fim" label="Data Final" className={'inline-block'} />
                                                        <DBSelectInput
                                                            name="verificacao_responsavel"
                                                            label="Responsável"
                                                            url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                            displaySelectField="nome"
                                                        />
                                                    </GroupInput>
                                                    <TextInput name="verificacao_descricao" label="Descrição" />
                                                    <SelectInput
                                                        name="verificacao_status"
                                                        label="Status"
                                                        listOptions={[{ value: 'Pendente' }, { value: 'Concluído' }]}
                                                        className={'inline-block'}
                                                    />
                                                </div>
                                            );
                                        }}
                                        validationSchema={yup.object().shape({
                                            verificacao_inicio: yup.date(),
                                            verificacao_fim: yup.date(),
                                            verificacao_responsavel: yup.string(),
                                            verificacao_status: yup.string(),
                                        })}
                                    />
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Validação
                                return (
                                    <FormInput
                                        document={`/griddocument/grid83/${item._id}`}
                                        perms={'83'}
                                        onRenderFields={() => {
                                            return (
                                                <div className="w-full">
                                                    <GroupInput>
                                                        <DateInputBR name="validacao_inicio" label="Data Início" className={'inline-block'} />
                                                        <DateInputBR name="validacao_fim" label="Data Final" className={'inline-block'} />
                                                        <DBSelectInput
                                                            name="validacao_responsavel"
                                                            label="Responsável"
                                                            url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                            displaySelectField="nome"
                                                        />
                                                    </GroupInput>
                                                    <TextInput name="validacao_descricao" label="Descrição" />
                                                    <SelectInput
                                                        name="validacao_status"
                                                        label="Status"
                                                        listOptions={[{ value: 'Pendente' }, { value: 'Concluído' }]}
                                                        className={'inline-block'}
                                                    />
                                                </div>
                                            );
                                        }}
                                        validationSchema={yup.object().shape({
                                            validacao_inicio: yup.date(),
                                            validacao_fim: yup.date(),
                                            validacao_responsavel: yup.string(),
                                            validacao_status: yup.string(),
                                        })}
                                    />
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Controle de Alterações
                                return (
                                    <div className={'m-2'}>
                                        <Grid
                                            url={`/griddocument/grid83-alteracao-${item._id}`}
                                            perms={'83'}
                                            disableModal={true}
                                            GridHeaders={[
                                                { title: 'Responsável', field: 'responsavel', sort: true, className: 'w-2/12 text-left pl-1' },
                                                { title: 'Descrição', field: 'descricao', sort: true, className: 'w-5/12 pl-1 text-left border-l border-gray-300' },
                                                { title: 'Observação', field: 'observacao', sort: true, className: 'w-4/12 pl-1 text-left border-l border-gray-300' },
                                                { title: 'Status', field: 'status', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                            ]}
                                            LineDataPrint={(data) => {
                                                return [data.crew?.nome, data.descricao, data.observacao, data.status];
                                            }}
                                            onRenderForm={() => {
                                                return (
                                                    <div className="w-full">
                                                        <GroupInput>
                                                            <DateInputBR name="inicio" label="Data Início" className={'inline-block'} />
                                                            <DateInputBR name="fim" label="Data Final" className={'inline-block'} />
                                                            <DBSelectInput
                                                                name="responsavel"
                                                                label="Responsável"
                                                                url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                displaySelectField="nome"
                                                            />
                                                        </GroupInput>
                                                        <TextInput name="descricao" label="Descrição" />
                                                        <TextInput name="observacao" label="Observação" />
                                                        <SelectInput
                                                            name="status"
                                                            label="Status"
                                                            className={'inline-block'}
                                                            listOptions={[{ value: 'Pendente' }, { value: 'Concluído' }]}
                                                        />
                                                    </div>
                                                );
                                            }}
                                            validationSchema={() => {
                                                return yup.object().shape({
                                                    responsavel: yup.string(),
                                                    descricao: yup.string(),
                                                    observacao: yup.string(),
                                                    status: yup.string(),
                                                });
                                            }}
                                        />
                                    </div>
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Anexo
                                return <GridAnexos url={`/attachment/form83-${item._id}`} disableModal={true} perms="83" />;
                            },
                        ]}
                        onBeforeDelete={async (item) => {
                            await System.apiDelete('/griddocument/grid83-entrada-' + item._id);
                            await System.apiDelete('/griddocument/grid83-saida-' + item._id);
                            await System.apiDelete('/griddocument/grid83-analise-' + item._id);
                            await System.apiDelete('/griddocument/grid83-analise-presenca-' + item._id);
                            await System.apiDelete('/griddocument/grid83-alteracao-' + item._id);
                            await System.apiDelete(`/attachment/form83-${item._id}`);
                        }}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url="/attachment/form83" perms="83" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form84 = () => {
    const System = useSystemContext();
    const [tipos, setTipos] = useState([]);
    const [categorias, setCategorias] = useState([]);


    var criterios = [];
    function getData() {
        System.apiGet('/griddocument/grid84-servicos').then((response) => {
            setTipos(response.data);
        });
        System.apiGet('/griddocument/grid84-categorias').then((response) => {
            setCategorias(response.data);
        });
    }

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, []);

    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form84"
                        perms={'84'}
                        title={System.getMenuTitle(84)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Gestão">
                    <Grid
                        url={'/griddocument/grid84'}
                        perms={'84'}
                        disableModal={true}
                        clearAutoEdit={true}
                        showPDFExport={true}
                        showCSVExport={true}
                        forceReloadAfterSave
                        GridHeaders={[
                            { title: 'Provedor Externo', field: 'provedor', sort: true, className: 'w-5/12 text-left pl-1' },
                            { title: 'Tipo', field: 'tipo', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Categoria', field: 'categoria', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Nota', field: 'lastNota', sort: true, className: 'w-1/12 pl-1 text-center border-l border-gray-300' },
                            { title: 'Responsável', field: 'responsavel', sort: true, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Reavaliação', field: 'reavaliacao', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Cadastro', field: 'statusCadastro', sort: false, filter: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },

                        ]}
                        onAfterLoadData={(received) => {
                            let result = received.map((data) => {
                                let revisao = data.revisao.sort((a, b) => a.data.localeCompare(b.data));
                                data.lastNota = revisao[revisao.length - 1];
                                return data;
                            });
                            return result;
                        }}
                        LineDataPrint={(data) => {
                            return [
                                data.provedor,
                                typeof tipos === 'object' ? tipos.find((item) => item.id === data.tipo)?.tipo : '',
                                typeof categorias === 'object' ? categorias.find((item) => item.id === data.categoria)?.titulo : '',
                                data.lastNota ? parseFloat(data.lastNota.notacalculada).toFixed(1) : '',
                                data.crew?.nome,
                                dateToString(data.reavaliacao),
                                data.statusCadastro === 'Inativo' ? <span className="text-red-400">Inativo</span> : <span>Ativo</span>,
                            ];
                        }}
                        validationSchema={yup.object().shape({
                            provedor: yup.string(),
                            tipo: yup.string(),
                            reavaliacao: yup.date(),
                        })}
                        onRenderForm={(GridModes, setFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <GroupInput>
                                        <Input name="codigo" label="Código" className={'w-1/4'} />
                                        <Input name="provedor" label="Provedor Externo" />
                                    </GroupInput>
                                    <GroupInput>
                                        <DateInputBR name="data" label="Data Cadastro / Atualização" information="Apartir desta data a nota do fornecedor volta a ser 10" />
                                        <DateInputBR name="reavaliacao" label="Data Reavaliação" />
                                        <SelectInput
                                            name="statusCadastro"
                                            label="Status do Cadastro"
                                            className={'w-3/6'}
                                            defaultValue={'Ativo'}
                                            listOptions={[{ option: 'Ativo' }, { option: 'Inativo' }]}
                                        />
                                    </GroupInput>
                                    <CepInput
                                        name="cep"
                                        label="CEP"
                                        className="w-44"
                                        onReceivedCep={(received) => {
                                            setFieldValue('endereco', received.logradouro);
                                            setFieldValue('bairro', received.bairro);
                                            setFieldValue('cidade', received.localidade);
                                            setFieldValue('estado', received.uf);
                                            setFieldValue('pais', 'Brasil');
                                        }}
                                    />
                                    <GroupInput>
                                        <Input name="endereco" label="Endereço" />
                                        <Input name="numero" label="Número" className="w-32" />
                                    </GroupInput>
                                    <GroupInput>
                                        <Input name="bairro" label="Bairro" />
                                        <Input name="cidade" label="Cidade" />
                                        <MaskInput
                                            name="estado"
                                            label="Estado"
                                            className="w-48"
                                            mask="aa"
                                            beforeMaskedValueChange={function (newState) {
                                                newState.value = newState.value.toUpperCase();
                                                return newState;
                                            }}
                                        />
                                        <Input name="pais" label="País" />
                                    </GroupInput>
                                    <GroupInput>
                                        <Input name="contato_1_nome" label="Contato 1" />
                                        <Input name="contato_1_email" label="Email" />
                                        <MaskInput name="contato_1_fone" label="Telefone" mask="(99) 9 9999-9999" />
                                    </GroupInput>
                                    <GroupInput>
                                        <Input name="contato_2_nome" label="Contato 2" />
                                        <Input name="contato_2_email" label="Email" />
                                        <MaskInput name="contato_2_fone" label="Telefone" mask="(99) 9 9999-9999" />
                                    </GroupInput>
                                    <GroupInput>
                                        <DBSelectInput name="tipo" label="Tipo" displaySelectField="tipo" url="/griddocument/grid84-servicos" />
                                        <SelectInput
                                            name="periodicidade"
                                            label="Periodicidade de Controle"
                                            listOptions={[
                                                { value: 'Mensal' },
                                                { value: 'Bimestral' },
                                                { value: 'Trimestral' },
                                                { value: 'Quatrimestral' },
                                                { value: 'Semestral' },
                                                { value: 'Anual' },
                                                { value: 'Bienal' },
                                            ]}
                                        />
                                    </GroupInput>
                                    <GroupInput>
                                        <DBSelectInput name="categoria" label="Categoria" displaySelectField="titulo" url="/griddocument/grid84-categorias" />
                                        <DBSelectInput name="responsavel" label="Responsável" url={GridModes.insert_mode ? '/crewactive' : '/crew'} displaySelectField="nome" />
                                    </GroupInput>
                                </div>
                            );
                        }}
                        FormTabs={[
                            () => {
                                return <div>Home</div>;
                            },
                            () => {
                                return <div>Inspeção</div>;
                            },
                            () => {
                                return <div>Gráfico</div>;
                            },
                            () => {
                                return <div>Anexos</div>;
                            },
                            () => {
                                return <div>Diário de Bordo</div>;
                            },
                        ]}
                        onSelectItem={async (item) => {
                            await System.apiGet(`/griddocument/grid84-${item.tipo}-criterios`).then((response) => {
                                criterios = response.data;
                            });
                        }}
                        onRenderFormExtra={[
                            (GridModes, item, GridRefresh) => {
                                // Inspeção
                                var localData = [];
                                var url = `/griddocument/grid84-ipde-${item._id}`;
                                function saveNotaFinal(item) {
                                    System.apiPut(`${url}/${item._id}`, item);
                                    return true;
                                }
                                return (
                                    <div className={'m-2'}>
                                        <Grid
                                            url={url}
                                            perms={'84'}
                                            defaultSortField={'data'}
                                            disableModal={true}
                                            GridHeaders={[
                                                { title: 'Data', field: 'data', type: 'date', sort: false, className: 'w-4/12 text-center pl-1' },
                                                { title: 'Nota Fiscal', field: 'notafiscal', sort: false, className: 'w-4/12 pl-1 text-center border-l border-gray-300' },
                                                { title: 'Nota Final', field: 'notacalculada', sort: false, className: 'w-4/12 pl-1 text-center border-l border-gray-300' },
                                            ]}
                                            LineDataPrint={(data) => {
                                                let printData = data;
                                                if (localData.length > 0) {
                                                    printData = localData.find((item) => item._id === data._id);
                                                }
                                                if (!('notacalculada' in printData)) {
                                                    printData.notacalculada = 0;
                                                }
                                                return [
                                                    dateToString(printData.data),
                                                    printData.notafiscal,
                                                    parseFloat(printData.notacalculada).toFixed(1)
                                                ];
                                            }}
                                            forceReloadAfterSave={true}
                                            onAfterLoadData={(oldReceived) => {
                                                // converte as chaves e valores para utf-8 evitando erro de acentos
                                                let received = [];
                                                let dt_atualizacao = new Date(item.data + ' 00:00:00') || new Date();
                                                let resetNota = isNaN(dt_atualizacao.getTime()) ? 0 : 1;

                                                oldReceived.forEach((item) => {
                                                    let tmp = {};
                                                    Object.entries(item).forEach(([key, value]) => {
                                                        const normalizedKey = normalizeText(key);
                                                        const normalizedValue = value; //normalizeText(value);
                                                        tmp[normalizedKey] = normalizedValue;
                                                    });
                                                    received.push(tmp);
                                                });
                                                // ---- [ final ]----------------
                                                const dtIni = new Date('2021-01-01');
                                                let foraPeriodo = 0;
                                                var notaAnterior = 10;
                                                let notacalculada = 0;
                                                let newData = received.map((item) => {
                                                    let dt = new Date(item.data + ' 00:00:00');
                                                    if (foraPeriodo === 0) {
                                                        if (dt >= dtIni) {
                                                            foraPeriodo = 1;
                                                            notaAnterior = 10;
                                                        }
                                                    }
                                                    if (resetNota === 1 && dt >= dt_atualizacao) {
                                                        resetNota = 0;
                                                        notaAnterior = 10;
                                                    }
                                                    notacalculada = notaAnterior;
                                                    criterios.forEach((criterio) => {
                                                        let criterioNome = normalizeText(criterio.criterio);
                                                        if (item[criterioNome] !== 'Atende') {
                                                            notacalculada -= criterio.demerito;
                                                        }
                                                    });
                                                    notaAnterior = notacalculada;
                                                    item.notacalculada = parseFloat(notacalculada);
                                                    saveNotaFinal(item);
                                                    return item;
                                                });
                                                localData = newData;
                                                return newData;
                                            }}
                                            onPrepareSaveRecord={(values) => {
                                                values.gridparent = item._id;
                                                let newForm = new FormData();
                                                for (let key in values) {
                                                    newForm.append(key, values[key]);
                                                }
                                                return newForm;
                                            }}
                                            onRenderForm={() => {
                                                return (
                                                    <div className="w-full">
                                                        <GroupInput>
                                                            <DateInputBR name="data" label="Data" />
                                                            <Input name="notafiscal" label="Nota Fiscal" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            {criterios.map((item, index) => {
                                                                return (
                                                                    <SelectInput
                                                                        key={index}
                                                                        name={normalizeText(item.criterio)}
                                                                        label={item.criterio}
                                                                        listOptions={[{ value: 'Atende' }, { value: 'Não Atende' }]}
                                                                    />
                                                                );
                                                            })}
                                                        </GroupInput>
                                                        <TextInput name="observacoes" label="Observações" rows={2} />
                                                    </div>
                                                );
                                            }}
                                            validationSchema={() => {
                                                return yup.object().shape({
                                                    data: yup.date().required('Data requerida'),
                                                });
                                            }}
                                        />
                                    </div>
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Grafico
                                return <Chart84 item={item} />;
                            },
                            (GridModes, item, GridRefresh) => {
                                // Anexos
                                return (
                                    <div className={'m-2'}>
                                        <GridAnexos url={`/attachment/grid84-${item._id}`} perms="84" />
                                    </div>
                                );
                            },
                            (GridModes, item, GridRefresh) => {
                                // Diário de Bordo
                                return (
                                    <div>
                                        {!GridModes.insert_mode && (
                                            <div className={'m-2'}>
                                                <GridDiario url={'/griddocument/grid84-diario-' + item._id} perms={'84'} />
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                        ]}
                        onBeforeDelete={async (item) => {
                            await System.apiDelete('/griddocument/grid84-ipde-' + item._id);
                            await System.apiDelete('/griddocument/grid84-categorias-' + item._id);
                            await System.apiDelete('/griddocument/grid84-diario-' + item._id);
                            await System.apiDelete('/attachment/grid84-' + item._id);
                        }}
                    />
                </TabPanel>
                <TabPanel>
                    <GridAnexos url={'/attachment/grid84'} perms="84" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form841 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form841"
                        perms="841"
                        title={System.getMenuTitle(841)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url={'/attachment/form841'} perms="841" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form842 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form842"
                perms="842"
                title={System.getMenuTitle(842)}
                initialValues={{
                    conteudo: '',
                }}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form843 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form843"
                perms="843"
                title={System.getMenuTitle(843)}
                initialValues={{
                    conteudo: '',
                }}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form851Normal = ({ System, empresa }) => {
    return (
        <div>
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form851"
                        perms="851"
                        title={System.getMenuTitle(851)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url="/attachment/form851" perms="851" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};

export const Form851Laudos = ({ System, empresa }) => {
    const [subGeneros, setSubGeneros] = useState([])
    const carregarGeneros = useCallback(async () => {
        try {
            const response = await System.apiGet('/sub-genero-alimento');
            if (response.status === 200) {
                setSubGeneros(response.data);
            }
            return true;
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
            return [];
        }

    }, [System]);

    useEffect(() => {
        carregarGeneros();
    }, [carregarGeneros]);

    const TranslateGenero = (id) => {
        const subGenero = subGeneros.find(item => item._id === id);
        return `${subGenero?.generoAlimento?.generoAlimento} - ${subGenero?.subGeneroAlimento}`;
    }

    const laudoAmostraTitulo = (laudo) => {
        const subGenero = subGeneros.find(item => item._id === laudo.subGrupoAlimento);
        return `${laudo.numeroLaudo ? laudo.numeroLaudo + ' - ' : ''}${subGenero?.generoAlimento?.generoAlimento} - ${subGenero?.subGeneroAlimento}`;
    }

    const getGeneroItem = (id) => subGeneros.find(item => item._id === id);

    const configLaudos = {
        pageWidth: 210,
        pageHeight: 297,
        margin: 15,
        borderMargin: 10,
        fontSize: {
            titulo: 11,
            subtitulo: 9,
            normal: 8,
            cabecalho: 10
        },
        cores: {
            cinzaClaro: [220, 220, 220]
        }
    };

    const Laudo851 = async (laudo, genero, dadosRelatorio) => {

        let amostras = [];
        try {
            let url = `/griddocument/grid851-amostra-${laudo._id}`;
            if (genero?.composicao === true) {
                url = `/griddocument/grid851-amostra-composicao-${laudo._id}`;
            }
            const response = await System.apiGet(url);
            if (response.status === 200) {
                amostras = response.data;
            }
        } catch (error) {
            console.error('Erro ao buscar amostras:', error);
        }

        const textNormal = () => {
            doc.setFontSize(fontSize.normal);
            doc.setFont('helvetica', 'normal');
        }

        // ********************************
        const doc = new jsPDF({
            orientation: 'portrait',
            unit: 'mm',
            format: 'a4'
        });
        // Espessura das linhas
        doc.setLineWidth(0.2);


        const { pageWidth, margin, fontSize, cores } = configLaudos;
        const contentWidth = pageWidth - (margin * 2);
        let y = 15;

        // ==================== FUNÇÕES AUXILIARES ====================

        // Função para normalizar caracteres especiais não suportados pela fonte helvetica
        const normalizeText = (text) => {
            if (!text) return '';
            return String(text)
                .replace(/≤/g, '<=')
                .replace(/≥/g, '>=')
                .replace(/±/g, '+/-')
                //.replace(/°/g, 'o')
                .replace(/²/g, '2')
                .replace(/³/g, '3')
                .replace(/µ/g, 'u')
                .replace(/×/g, 'x')
                .replace(/÷/g, '/')
                .replace(/•/g, '-')
                .replace(/–/g, '-')
                .replace(/—/g, '-')
                .replace(/'/g, "'")
                .replace(/'/g, "'")
                .replace(/"/g, '"')
                .replace(/"/g, '"');
        };

        const drawCell = (x, width, height, texto, opcoes = {}) => {
            const {
                bold = false,
                italic = false,
                align = 'left',
                tamanhoFonte = fontSize.normal,
                bgColor = null,
                paddingX = 2,
                paddingY = null
            } = opcoes;

            // Fundo
            if (bgColor) {
                doc.setFillColor(bgColor[0], bgColor[1], bgColor[2]);
                doc.rect(x, y, width, height, 'F');
            }

            // Borda
            doc.rect(x, y, width, height, 'S');

            // Texto
            doc.setFontSize(tamanhoFonte);
            doc.setFont('helvetica', bold ? 'bold' : (italic ? 'italic' : 'normal'));

            let textX = x + paddingX;
            if (align === 'center') textX = x + width / 2;
            if (align === 'right') textX = x + width - paddingX;

            const textY = paddingY !== null ? y + paddingY : y + (height / 2) + 1;
            doc.text(normalizeText(texto), textX, textY, { align });
        };

        const drawHeader = (texto, altura = 6) => {
            drawCell(margin, contentWidth, altura, texto, {
                bold: true,
                align: 'center',
                tamanhoFonte: fontSize.subtitulo,
                bgColor: cores.cinzaClaro
            });
            y += altura;
        };

        /*
        const drawTexto = (label, valor, xOffset = 0) => {
            doc.setFontSize(fontSize.normal);
            doc.setFont('helvetica', 'bold');
            doc.text(label, margin + xOffset, y);
            doc.setFont('helvetica', 'normal');
            doc.text(valor, margin + xOffset + doc.getTextWidth(label) + 1, y);
        };
        */

        // Verificar se precisa quebra de página
        const verificaFimDePagina = (limite = 260) => {
            if (y > limite) {
                doc.setDrawColor(0);
                doc.rect(configLaudos.borderMargin, configLaudos.borderMargin, pageWidth - (configLaudos.borderMargin * 2), configLaudos.pageHeight - (configLaudos.borderMargin * 2));
                doc.addPage();
                y = margin; // seta o inicio na margem superior
            }
        }


        // ==================== CARREGAR BRASÃO ====================
        const loadImage = (src) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.crossOrigin = 'Anonymous';
                img.onload = () => resolve(img);
                img.onerror = reject;
                img.src = src;
            });
        };


        /**
         * Calcula a altura necessária para uma célula sem desenhá-la
         * @param {number} posicao - Posição horizontal da célula (1, 2, 3, ...)
         * @param {number} divisoes - Número total de divisões/colunas na linha
         * @param {string} texto - Conteúdo de texto a ser calculado
         * @param {Object} opcoes - Opções de formatação
         * @param {number} [opcoes.paddingX=2] - Espaçamento horizontal interno (mm)
         * @param {number} [opcoes.paddingY=1] - Espaçamento vertical interno (mm)
         * @param {number} [opcoes.lineHeight=3] - Altura de cada linha de texto (mm)
         * @param {number} [opcoes.colSpan=1] - Número de colunas que a célula ocupa
         * @param {number} [opcoes.fontSize=8] - Tamanho da fonte do texto (pt)
         * @returns {number} Altura calculada da célula (mm)
         */
        const calcCellHeight = (posicao = 1, divisoes = 1, texto = ' ', opcoes = {}) => {
            const {
                paddingX = 2,
                paddingY = 1,
                lineHeight = 3,
                colSpan = 1,
                fontSize: customFontSize = 8
            } = opcoes;

            const singleCellWidth = contentWidth / divisoes;
            const cellWidth = singleCellWidth * colSpan;
            const textWidth = cellWidth - (paddingX * 2);

            doc.setFontSize(customFontSize);
            const textoNormalizado = normalizeText(texto ?? '');
            const linhas = doc.splitTextToSize(textoNormalizado, textWidth);

            const textTotalHeight = linhas.length * lineHeight;
            return Math.max(4, textTotalHeight + (paddingY * 2));
        };

        /**
         * Desenha uma linha de células com altura uniforme
         * @param {Array<{texto: string, opcoes?: Object}>} celulas - Array de células a desenhar (ordem = posição)
         * @param {string} celulas[].texto - Conteúdo de texto da célula
         * @param {Object} [celulas[].opcoes] - Opções de formatação (mesmas opções do drawCellW)
         * @returns {number} Altura da linha desenhada (mm)
         * @example
         * drawLine([
         *   { content: 'Coluna 1' },
         *   { content: 'Coluna 2', opcoes: { align: 'center' } },
         *   { content: 'Coluna 3', opcoes: { bold: true } }
         * ]);
         */
        const drawLine = (celulas, totalColunas = 0) => {
            const divisoes = Math.max(totalColunas, celulas.length);

            // Calcular posições considerando colSpan
            let posicaoAtual = 1;
            const posicoesEColSpans = celulas.map((cel) => {
                const colSpan = cel.opcoes?.colSpan || 1;
                const posicao = posicaoAtual;
                posicaoAtual += colSpan;
                return { posicao, colSpan };
            });

            // Calcular altura máxima necessária
            const alturas = celulas.map((cel, index) =>
                calcCellHeight(posicoesEColSpans[index].posicao, divisoes, cel.content, cel.opcoes || {})
            );
            const maxHeight = Math.max(...alturas);

            // Desenhar todas as células com a mesma altura
            celulas.forEach((cel, index) => {
                drawCellW(posicoesEColSpans[index].posicao, divisoes, cel.content, { ...cel.opcoes, height: maxHeight });
            });

            // Incrementar y e retornar altura
            y += maxHeight;
            return maxHeight;
        };

        /**
         * Desenha uma célula com texto no PDF
         * @param {number} posicao - Posição horizontal da célula (1, 2, 3, ...)
         * @param {number} divisoes - Número total de divisões/colunas na linha
         * @param {string} texto - Conteúdo de texto a ser impresso na célula
         * @param {Object} opcoes - Opções de formatação da célula
         * @param {boolean} [opcoes.bold=false] - Se o texto deve ser em negrito
         * @param {'left'|'center'|'right'} [opcoes.align='left'] - Alinhamento horizontal do texto
         * @param {'top'|'middle'|'bottom'} [opcoes.verticalAlign='top'] - Alinhamento vertical do texto
         * @param {number} [opcoes.paddingX=2] - Espaçamento horizontal interno (mm)
         * @param {number} [opcoes.paddingY=1] - Espaçamento vertical interno (mm)
         * @param {number} [opcoes.lineHeight=3] - Altura de cada linha de texto (mm)
         * @param {number} [opcoes.colSpan=1] - Número de colunas que a célula ocupa
         * @param {number} [opcoes.rowSpan=1] - Número de linhas que a célula ocupa
         * @param {number} [opcoes.rowHeight=5] - Altura padrão de uma linha para cálculo do rowSpan (mm)
         * @param {boolean} [opcoes.border=true] - Se deve desenhar a borda da célula
         * @param {number} [opcoes.fontSize=8] - Tamanho da fonte do texto (pt)
         * @param {number} [opcoes.height=null] - Altura fixa da célula (mm). Se informado, ignora cálculo automático
         * @returns {number} Altura da célula desenhada (mm)
         */
        const drawCellW = (posicao = 1, divisoes = 1, texto = ' ', opcoes = {}) => {
            const {
                bold = false,
                italic = false,
                align = 'left',
                verticalAlign = 'top',
                paddingX = 2,
                paddingY = 1,
                lineHeight = 3,
                colSpan = 1,
                rowSpan = 1,
                rowHeight = 5, // altura padrão de uma linha para cálculo do rowSpan
                border = true,
                fontSize: customFontSize = 8,
                height = null
            } = opcoes;

            const singleCellWidth = contentWidth / divisoes;
            const cellWidth = singleCellWidth * colSpan; // Largura total considerando colSpan
            const cellX = margin + (singleCellWidth * (posicao - 1));
            const textWidth = cellWidth - (paddingX * 2);

            doc.setFontSize(customFontSize);
            doc.setFont('helvetica', bold ? 'bold' : (italic ? 'italic' : 'normal'));

            const textoNormalizado = normalizeText(texto ?? '');
            const linhas = doc.splitTextToSize(textoNormalizado, textWidth);

            // Altura: usa height fixo ou calcula baseado no conteúdo
            const textTotalHeight = linhas.length * lineHeight;
            const textHeight = textTotalHeight + (paddingY * 2);
            const spanHeight = rowSpan * rowHeight;
            const cellHeight = height !== null ? height : Math.max(4, textHeight, spanHeight);

            // Desenhar borda se habilitado
            if (border) {
                doc.setLineWidth(0.2);
                doc.rect(cellX, y, cellWidth, cellHeight, 'S');
            }

            let textX = cellX + paddingX;
            if (align === 'center') textX = cellX + (cellWidth / 2);
            if (align === 'right') textX = cellX + cellWidth - paddingX;

            // Posicionar texto verticalmente
            let textY;
            if (verticalAlign === 'middle') {
                textY = y + (cellHeight - textTotalHeight) / 2 + 2.5;
            } else if (verticalAlign === 'bottom') {
                textY = y + cellHeight - textTotalHeight - paddingY + 2.5;
            } else {
                // top (default)
                textY = y + paddingY + 2.5;
            }
            doc.text(linhas, textX, textY, { align });

            return cellHeight;
        }

        const drawCellWFull = (texto = ' ', opcoes = {}) => {
            y += drawCellW(1, 1, texto, opcoes);
        }


        try {
            const brasao = await loadImage('/brasao.jpg');
            doc.addImage(brasao, 'JPEG', margin, y, 25, 25);
        } catch (e) {
            console.warn('Brasão não carregado:', e);
        }

        // ==================== CABEÇALHO ====================
        doc.setFontSize(fontSize.cabecalho);
        doc.setFont('helvetica', 'bold');
        const headerX = margin + 35;
        doc.text(dadosRelatorio.orgao.linha1, headerX, y + 5);
        doc.text(dadosRelatorio.orgao.linha2, headerX, y + 10);
        doc.text(dadosRelatorio.orgao.linha3, headerX, y + 15);
        doc.text(dadosRelatorio.orgao.linha4, headerX, y + 20);

        y = 47;

        // ==================== TÍTULO ====================

        // ==================== INFORMAÇÕES GERAIS ====================
        if (genero?.agua === true) {
            drawCellWFull(`RELATÓRIO DE ANÁLISE ${laudo.numeroLaudo}`, { border: false, align: 'center' });

            drawCellWFull(`OM: ${laudo.om}`, { border: false });
            drawCellWFull(`Endereço: ${laudo.omEndereco}`, { border: false });
            drawCellWFull(`Documento de requisição: ${laudo.omRequisicao}`, { border: false });
        } else {
            drawHeader(`LAUDO FISCAL: ${laudo.numeroLaudo}`);
            drawCellWFull(`Artigo: ${laudo?.artigo ?? '<Não informado>'}`);
            drawLine([
                { content: `Empresa: ${laudo?.empresa ?? '<Não informado>'}`, opcoes: { verticalAlign: 'middle' } },
                { content: `Pregão: ${laudo?.pregao ?? '<Não informado>'}`, opcoes: { verticalAlign: 'middle' } }
            ]);

            drawLine([
                { content: `Lote: ${laudo?.lote ?? '<Não informado>'}`, opcoes: { verticalAlign: 'middle' } },
                { content: `Amostra: ${laudo?.amostra ?? '<Não informado>'}`, opcoes: { verticalAlign: 'middle' } }
            ]);

            drawLine([
                { content: `Empenho: ${laudo?.notaEmpenho ?? '<Não informado>'}`, opcoes: { verticalAlign: 'middle' } },
                { content: `Nota Fiscal: ${laudo?.nf ?? '<Não informado>'}`, opcoes: { verticalAlign: 'middle' } }
            ]);

            y += 6; // espaço em branco

            // IDENTIFICAÇÃO DO ARTIGO
            drawHeader('IDENTIFICAÇÃO DO ARTIGO');
            let artigoValidades = [];
            try {
                const response = await System.apiGet(`/griddocument/grid851-artigoValidades-${laudo._id}`);
                if (response.status === 200) {
                    artigoValidades = response.data;
                }
            } catch (error) {
                console.error('Erro ao buscar fisicoQuimicos:', error);
            }
            drawLine([
                { content: `Fabricante: ${laudo?.fabricante ?? '<Não informado>'}` },
                { content: `CNPJ: ${laudo?.cnpj ?? '<Não informado>'}` }
            ]);
            drawCellWFull(`SIF: ${laudo?.sif ?? '<Não informado>'}`);
            //
            drawLine([
                { content: `Marca: ${laudo?.marca ?? '<Não informado>'}` },
                { content: `Lote: ${laudo?.numeroLote ?? '<Não informado>'}` }
            ]);
            if (artigoValidades.length > 0) {
                for (const artigoValidade of artigoValidades) {
                    drawCellW(3, 4, `Fabricação: ${dateToString(artigoValidade.fabricacao)}`);
                    y += drawCellW(4, 4, `Validade: ${dateToString(artigoValidade.validade)}`);
                }
            }

            // EMBALAGEM E ROTULAGEM
            drawHeader('EMBALAGEM E ROTULAGEM');
            drawCellWFull(`Embalagem primária: ${laudo?.embalagemPrimaria}`)
            drawCellWFull(`Embalagem secundária: ${laudo?.embalagemSecundaria}`)
            //
            drawCellW(1, 2, `Conteúdo líquido: ${laudo?.conteudoLiquido ?? '<Não informado>'}`);
            y += drawCellW(2, 2, `Rotulagem: ${laudo?.rotulagem ?? '<Não informado>'}`);
            //
            drawCellWFull(`Observações: ${laudo?.embalagemObservacoes ?? 'Nenhuma observação'}`);
            if (genero?.composicao === true) {
                drawCellWFull(`Exame de Conteúdo`, { align: 'center', bold: true });
                drawCellWFull(`Líquido: ${laudo?.embalagemLiquidoExame ?? ''}`);
                drawCellWFull(`Acessórios: ${laudo?.embalagemAcessoriosExame ?? ''}`);
            }
        }



        // ==================== SEÇÕES DE COLETA ====================
        for (const amostra of amostras) {

            if (genero?.composicao === true) {
                const generoComposicao = getGeneroItem(amostra?.subGrupoAlimento);
                y += 3;
                drawHeader(`${getGeneroItem(amostra.subGrupoAlimento)?.subGeneroAlimento ?? ''}`);
                //
                drawLine([
                    { content: `Termo de Coleta: ${amostra.termoAmostra ?? ''}` },
                    { content: `Lote: ${amostra.lote ?? ''}` },
                ]);
                //
                drawLine([
                    { content: `Fabricação: ${dateToString(amostra.fabricacao)}` },
                    { content: `Validade: ${dateToString(amostra.fabricacao)}` },
                    { content: `Peso líquido: ${amostra.pesoLiquido}` },
                    { content: `Padrão: ${amostra.padrao}` }
                ]);
                // CRITÉRIO MICROBIOLÓGICO - Composição
                if (generoComposicao.microbiologico) {
                    let ensaiosComposicao = [];
                    try {
                        const response = await System.apiGet(`/griddocument/grid851-amostra-composicao-${laudo._id}-microbiologico-${amostra._id}`);
                        if (response.status === 200) {
                            ensaiosComposicao = response.data;
                        }
                    } catch (error) {
                        console.error('Erro ao buscar ensaios:', error);
                    }

                    drawHeader('CRITÉRIO MICROBIOLÓGICO');
                    drawCellW(1, 12, `ENSAIO`, { colSpan: 3 });
                    drawCellW(4, 12, `n`);
                    drawCellW(5, 12, `c`);
                    drawCellW(6, 12, `m`);
                    drawCellW(7, 12, `M`);
                    drawCellW(8, 12, `ANÁLISE`, { colSpan: 2 });
                    y += drawCellW(10, 12, `RESULTADO`, { colSpan: 3 });

                    // Linhas de ensaios
                    for (const ensaio of ensaiosComposicao) {
                        y += drawLine([
                            { content: ensaio.microorganismos ?? '', opcoes: { colSpan: 3 } },
                            { content: ensaio.n ?? '', opcoes: { colSpan: 1 } },
                            { content: ensaio.c ?? '', opcoes: { colSpan: 1 } },
                            { content: ensaio.m ?? '', opcoes: { colSpan: 1 } },
                            { content: ensaio.mm ?? '', opcoes: { colSpan: 1 } },
                            { content: ensaio.analise ?? '', opcoes: { colSpan: 2 } },
                            { content: ensaio.resultado ?? '', opcoes: { colSpan: 3 } }
                        ], 12);
                    }

                    // Método utilizado
                    if (amostra.microbiologicoMetodo && amostra.microbiologicoMetodo.trim() !== '') {
                        drawCellWFull(`Método utilizado: ${amostra.microbiologicoMetodo ?? ''}`);
                    }
                }
                // Análise microbiológica - Composição
                if (generoComposicao.analiseMicrobiologica) {
                    drawHeader('ANÁLISE MICROBIOLÓGICA');
                    drawCellWFull(amostra?.analiseMicrobiologicaDetalhamento ?? '');
                }
                // -------------------
                verificaFimDePagina();
                // -------------------
                // CRITÉRIO FÍSICO-QUÍMICO - Composição
                if (generoComposicao.fisicoQuimico) {
                    let fisicoQuimicosComposicao = [];
                    try {
                        const response = await System.apiGet(`/griddocument/grid851-amostra-composicao-${laudo._id}-fisicoQuimico-${amostra._id}`);
                        if (response.status === 200) {
                            fisicoQuimicosComposicao = response.data;
                        }
                    } catch (error) {
                        console.error('Erro ao buscar fisicoQuimicos:', error);
                    }
                    if (fisicoQuimicosComposicao.length > 0) {
                        drawHeader('CRITÉRIO FÍSICO-QUÍMICO');
                        drawCellW(1, 3, `DETERMINAÇÕES`, { bold: true, align: 'center' });
                        drawCellW(2, 3, `ANÁLISE`, { bold: true, align: 'center' });
                        y += drawCellW(3, 3, `PADRÃO`, { bold: true, align: 'center' });
                        for (const fisicoQuimico of fisicoQuimicosComposicao) {
                            y += drawLine([
                                { content: fisicoQuimico.determinacao ?? '' },
                                { content: fisicoQuimico.analise ?? '' },
                                { content: fisicoQuimico.padrao ?? '' }
                            ]);
                        }
                    }
                }
                // -------------------
                verificaFimDePagina();
                // -------------------
                //  ANÁLISE MACROSCÓPICA - Composição
                if (generoComposicao.macroscopico) {
                    drawHeader('ANÁLISE MACROSCÓPICA');
                    drawCellWFull(amostra?.macroscopicoDetalhamento ?? '');
                }
                // -------------------
                verificaFimDePagina();
                // -------------------
                // CRITÉRIO ORGANOLÉPTICO - Composição
                if (generoComposicao.organoleptico) {
                    drawHeader('CRITÉRIO ORGANOLÉPTICO');
                    drawCellWFull(`Características organolépticas: ${amostra.caracteristicasOrganolepticas}`);
                }
                // -------------------
                verificaFimDePagina();
                // -------------------
                // CLASSIFICAÇÃO MERCEOLÓGICA - Composição
                if (generoComposicao.merceologico) {
                    drawHeader('CLASSIFICAÇÃO MERCEOLÓGICA');
                    drawCellW(1, 2, `Classe: ${amostra.classe ?? ''}`);
                    y += drawCellW(2, 2, `Tipo: ${amostra.tipo ?? ''}`);
                    drawCellWFull(`Certificado de classificação: ${amostra.certificadoClassificacaoMerceologico ?? ''}`);
                }
                // -------------------
                verificaFimDePagina();
                // -------------------
                // CLASSIFICAÇÃO DO PRODUTO - Composição
                if (generoComposicao.classificatorio) {
                    drawHeader('CLASSIFICAÇÃO DO PRODUTO');
                    drawCellW(1, 4, `Grupo: ${amostra.grupo ?? ''}`);
                    drawCellW(2, 4, `Classe: ${amostra.subgrupo ?? ''}`);
                    drawCellW(3, 4, `Classe: ${amostra.classe ?? ''}`);
                    y += drawCellW(4, 4, `Tipo: ${amostra.tipo ?? ''}`);
                    drawCellWFull(`Certificado de classificação: ${amostra.certificadoClassificacaoProduto ?? ''}`);
                }
                // -------------------
                verificaFimDePagina();
                // -------------------
                // CRITÉRIO MICROSCÓPICO - Composição
                if (generoComposicao.microscopico) {
                    drawHeader('CRITÉRIO MICROSCÓPICO');
                    drawCellWFull(amostra?.microscopicoDetalhamento ?? '');
                }
            } else {
                drawHeader('COLETA DA AMOSTRA');
                drawCellW(1, 4, `Data: ${dateToString(amostra.dataAmostra) ?? ''}`);
                drawCellW(2, 4, `Termo: ${amostra.termoAmostra ?? ''}`);
                drawCellW(3, 4, `Quantidade: ${amostra?.quantiaAmostra ?? ''}`);
                y += drawCellW(4, 4, `Local: ${amostra?.localColetaAmostra ?? 'Não informado'}`);
                drawCellWFull(`Responsável: ${amostra?.responsavelAmostra ?? 'Não informado'}`);

                // CRITÉRIO MICROBIOLÓGICO
                if (genero.microbiologico) {
                    let ensaios = [];
                    try {
                        const response = await System.apiGet(`/griddocument/grid851-amostra-${laudo._id}-microbiologico-${amostra._id}`);
                        if (response.status === 200) {
                            ensaios = response.data;
                        }
                    } catch (error) {
                        console.error('Erro ao buscar ensaios:', error);
                    }

                    drawHeader('CRITÉRIO MICROBIOLÓGICO');
                    if (genero.agua) {
                        drawCellW(1, 4, `ENSAIO`);
                        drawCellW(2, 4, `ANÁLISE`);
                        drawCellW(3, 4, `RESULTADO`);
                        y += drawCellW(4, 4, `PADRÃO`);
                    } else {
                        drawCellW(1, 12, `ENSAIO`, { colSpan: 3 });
                        drawCellW(4, 12, `n`);
                        drawCellW(5, 12, `c`);
                        drawCellW(6, 12, `m`);
                        drawCellW(7, 12, `M`);
                        drawCellW(8, 12, `ANÁLISE`, { colSpan: 2 });
                        y += drawCellW(10, 12, `RESULTADO`, { colSpan: 3 });
                    }

                    // Linhas de ensaios
                    for (const ensaio of ensaios) {
                        if (genero.agua) {
                            y += drawLine([
                                { content: ensaio?.microorganismos ?? '' },
                                { content: ensaio?.analise ?? '' },
                                { content: ensaio?.resultado ?? '' },
                                { content: ensaio?.padrao ?? '' },
                            ]);
                        } else {
                            y += drawLine([
                                { content: ensaio.microorganismos ?? '', opcoes: { colSpan: 3 } },
                                { content: ensaio.n ?? '', opcoes: { colSpan: 1 } },
                                { content: ensaio.c ?? '', opcoes: { colSpan: 1 } },
                                { content: ensaio.m ?? '', opcoes: { colSpan: 1 } },
                                { content: ensaio.mm ?? '', opcoes: { colSpan: 1 } },
                                { content: ensaio.analise ?? '', opcoes: { colSpan: 2 } },
                                { content: ensaio.resultado ?? '', opcoes: { colSpan: 3 } }
                            ], 12);
                        }
                    }


                    // Método utilizado
                    if (amostra.microbiologicoMetodo && amostra.microbiologicoMetodo.trim() !== '') {
                        drawCellWFull(`Método utilizado: ${amostra.microbiologicoMetodo ?? ''}`);
                    }
                }
                // Análise microbiológica
                if (genero.analiseMicrobiologica) {
                    drawHeader('ANÁLISE MICROBIOLÓGICA');
                    drawCellWFull(amostra?.analiseMicrobiologicaDetalhamento ?? '');
                }


                // -------------------
                verificaFimDePagina();
                // -------------------

                // CRITÉRIO ORGANOLÉPTICO
                if (genero.organoleptico) {
                    drawHeader('CRITÉRIO ORGANOLÉPTICO');
                    drawCellWFull(`Características organolépticas: ${amostra.caracteristicasOrganolepticas}`);
                }

                // -------------------
                verificaFimDePagina();
                // -------------------

                // CLASSIFICAÇÃO MERCEOLÓGICA
                if (genero.merceologico) {
                    drawHeader('CLASSIFICAÇÃO MERCEOLÓGICA');
                    drawCellW(1, 2, `Classe: ${amostra.classe ?? ''} `);
                    y += drawCellW(2, 2, `Tipo: ${amostra.tipo ?? ''} `);
                    drawCellWFull(`Certificado de classificação: ${amostra.certificadoClassificacaoMerceologico ?? ''}`);
                }

                // -------------------
                verificaFimDePagina();
                // -------------------

                // CLASSIFICAÇÃO DO PRODUTO
                if (genero.classificatorio) {
                    drawHeader('CLASSIFICAÇÃO DO PRODUTO');
                    drawCellW(1, 4, `Grupo: ${amostra.grupo ?? ''}`);
                    drawCellW(2, 4, `Classe: ${amostra.subgrupo ?? ''}`);
                    drawCellW(3, 4, `Classe: ${amostra.classe ?? ''}`);
                    y += drawCellW(4, 4, `Tipo: ${amostra.tipo ?? ''}`);
                    drawCellWFull(`Certificado de classificação: ${amostra.certificadoClassificacaoProduto ?? ''}`);
                }

                // -------------------
                verificaFimDePagina();
                // -------------------

                // ANÁLISE MACROSCÓPICA
                if (genero.macroscopico) {
                    drawHeader('ANÁLISE MACROSCÓPICA');
                    drawCellWFull(amostra?.macroscopicoDetalhamento ?? '');
                }

                // CRITÉRIO MICROSCÓPICO
                if (genero.microscopico) {
                    drawHeader('CRITÉRIO MICROSCÓPICO');
                    drawCellWFull(amostra?.microscopicoDetalhamento ?? '');
                }

                // -------------------
                verificaFimDePagina(230);
                // -------------------

                // QUALIDADE GLOBAL DA BEBIDA
                if (genero.bebida) {
                    let bebidaQualidades = [];
                    try {
                        const response = await System.apiGet(`/griddocument/grid851-amostra-${laudo._id}-bebida-${amostra._id}`);
                        if (response.status === 200) {
                            bebidaQualidades = response.data;
                        }
                    } catch (error) {
                        console.error('Erro ao buscar bebidaQualidades:', error);
                    }
                    if (bebidaQualidades.length > 0) {
                        drawHeader('QUALIDADE GLOBAL DA BEBIDA');
                        drawCellW(1, 3, `CATEGORIA`, { bold: true, align: 'center' });
                        drawCellW(2, 3, `ANÁLISE`, { bold: true, align: 'center' });
                        y += drawCellW(3, 3, `PADRÃO`, { bold: true, align: 'center' });
                        for (const bebidaQualidade of bebidaQualidades) {
                            drawCellW(1, 3, bebidaQualidade.categoria ?? '');
                            drawCellW(2, 3, bebidaQualidade.resultado ?? '');
                            y += drawCellW(3, 3, bebidaQualidade.padrao ?? '');
                        }
                    }
                }

                // -------------------
                verificaFimDePagina(200);
                // -------------------

                // CRITÉRIO FÍSICO-QUÍMICO
                if (genero.fisicoQuimico) {
                    let fisicoQuimicos = [];
                    try {
                        const response = await System.apiGet(`/griddocument/grid851-amostra-${laudo._id}-fisicoQuimico-${amostra._id}`);
                        if (response.status === 200) {
                            fisicoQuimicos = response.data;
                        }
                    } catch (error) {
                        console.error('Erro ao buscar fisicoQuimicos:', error);
                    }
                    if (fisicoQuimicos.length > 0) {
                        drawHeader('CRITÉRIO FÍSICO-QUÍMICO');
                        drawCellW(1, 3, `DETERMINAÇÕES`, { bold: true, align: 'center' });
                        drawCellW(2, 3, `ANÁLISE`, { bold: true, align: 'center' });
                        y += drawCellW(3, 3, `PADRÃO`, { bold: true, align: 'center' });
                        for (const fisicoQuimico of fisicoQuimicos) {
                            y += drawLine([
                                { content: fisicoQuimico.determinacao ?? '' },
                                { content: fisicoQuimico.analise ?? '' },
                                { content: fisicoQuimico.padrao ?? '' }
                            ]);
                        }
                    }
                }

                // /////////////////////////////////////
                // Final dos itens da amostra
                y += 8;
            }
        }

        // ==================== PARECER ====================
        // Verificar se precisa quebrar página
        verificaFimDePagina();

        y += 3;
        drawHeader('PARECER');
        drawCellWFull(`Resultado: ${laudo.parecerStatus ?? '<Não informado>'}`, { border: false });
        drawCellWFull(laudo?.parecerDetalhamento ?? '<Detalhamento não informado>', { border: false });
        y += 1;

        // ==================== REJEIÇÃO ====================
        if (laudo.parecerStatus !== 'Atende') {
            if (laudo.parecerMotivoRejeicao && laudo.parecerMotivoRejeicao.trim() !== '') {
                drawHeader('MOTIVO DA REJEIÇÃO');
                drawCellWFull(laudo.parecerMotivoRejeicao ?? '<Não informado>');
            }
        }

        // ==================== OBSERVAÇÃO ====================

        if (laudo.parecerObservacao && laudo.parecerObservacao.trim() !== '') {
            drawHeader('OBSERVAÇÃO');
            drawCellWFull(laudo.parecerObservacao ?? '<vazio>', { border: false });
        }

        // ==================== RODAPÉ ====================
        drawCellW(1, 2, `Local: ${laudo?.parecerLocal ?? '<não informado>'}`);
        y += drawCellW(2, 2, `Data: ${dateToString(laudo?.parecerDataEmissao)}`);

        // ==================== ASSINATURA ====================
        if (y < 250) { // Verifica se ainda ha espaço para a assinatura, entao adiciona espaço
            y += 25;
        } else {
            if (y > 275) { // verifica se ja estourou a pagina
                doc.addPage();
                y = 10;
            } else {
                y = 275; // fixar a assinatura no ponto mais baixo da pagina
            }
        }

        drawCellWFull(laudo.parecerResponsavel ?? '<Não informado>', { align: 'center', border: false, bold: true })
        drawCellWFull(laudo.parecerResponsavelFuncao ?? '', { align: 'center', border: false, bold: true });

        // ==================== BORDA EXTERNA ====================
        doc.setDrawColor(0);
        doc.rect(configLaudos.borderMargin, configLaudos.borderMargin, pageWidth - (configLaudos.borderMargin * 2), configLaudos.pageHeight - (configLaudos.borderMargin * 2));

        // ==================== NOVA PÁGINA - DESPACHO ====================
        if (genero?.agua !== true) {
            doc.addPage();
            y = margin + 4;

            // Borda externa da nova página
            doc.setDrawColor(0);
            doc.rect(configLaudos.borderMargin, configLaudos.borderMargin, pageWidth - (configLaudos.borderMargin * 2), configLaudos.pageHeight - (configLaudos.borderMargin * 2));

            // Título
            doc.setFontSize(fontSize.titulo);
            doc.setFont('helvetica', 'bold');
            doc.text('DESPACHO', pageWidth / 2, y, { align: 'center' });
            y += 10;

            textNormal();

            drawCellW(1, 6, "Com o parecer do inspecionador:", { colSpan: 2, align: 'right', border: false });
            drawCellW(3, 6, laudo.despachoConcordo === 'Concordo' ? "( X ) Concordo" : "(   ) Concordo", { border: false });
            drawCellW(4, 6, laudo.despachoConcordo === 'Não concordo' ? "( X ) Não concordo" : "(   ) Não concordo", { border: false });
            y += 6;
            //
            drawCellW(1, 6, "Artigo deve ser:", { colSpan: 2, align: 'right', border: false });
            drawCellW(3, 6, laudo.despachoArtigoRecusado === 'Recebido' ? "( X ) Recebido" : "(   ) Recebido", { border: false });
            drawCellW(4, 6, laudo.despachoArtigoRecusado === 'Recusado' ? "( X ) Recusado" : "(   ) Recusado", { border: false });
            y += 6;
            //
            drawCellW(1, 6, "Notifique-se o fornecedor:", { colSpan: 2, align: 'right', border: false });
            drawCellW(3, 6, laudo.despachoNotificarFornecedor === 'Sim' ? "( X ) Sim" : "(   ) Sim", { border: false });
            drawCellW(4, 6, laudo.despachoNotificarFornecedor === 'Não' ? "( X  ) Não" : "(   ) Não", { border: false });
            y += 6;
            //
            drawCellW(1, 6, "Notifique-se o órgão fiscalizador competente:", { colSpan: 2, align: 'right', border: false });
            drawCellW(3, 6, laudo.despachoNotificarFiscalizacao === 'Sim' ? "( X ) Sim" : "(   ) Sim", { border: false });
            drawCellW(4, 6, laudo.despachoNotificarFiscalizacao === 'Não' ? "( X ) Não" : "(   ) Não", { border: false });
            y += 6;
            //

            y += 15;

            // Seção Justificativa
            drawCellW(1, 1, "JUSTIFICATIVA", { border: false, bold: true });
            y += 5;
            y += drawCellW(1, 1, "(Quando o artigo estiver fora de conformidade com os Padrões de Identidade e Qualidade previstos no Boletim Técnico de Especificação Técnica de Artigo de Subsistência e/ou em desacordo com a Legislação oficial)", { border: false, fontSize: 6, italic: true });
            y += drawCellW(1, 1, laudo.despachoJustificativa ?? 'Não há justificativa a registrar.', { border: false });

            y += 30;

            // Linha de assinatura
            const linhaAssinaturaWidth = 80;
            const linhaAssinaturaX = (pageWidth - linhaAssinaturaWidth) / 2;
            doc.line(linhaAssinaturaX, y, linhaAssinaturaX + linhaAssinaturaWidth, y);
            y += 5;

            // Nome do responsável centralizado
            doc.setFontSize(fontSize.cabecalho);
            doc.setFont('helvetica', 'bold');
            doc.text(laudo.despachoResponsavel ?? '', pageWidth / 2, y, { align: 'center' });
            y += 5;
            doc.text(laudo.despachoResponsavelFuncao ?? '', pageWidth / 2, y, { align: 'center' });
        }

        // Salve o PDF
        doc.save(`laudo_851_${laudo.numeroLaudo ?? new Date().toISOString().split('T')[0]}.pdf`);
    }

    return (
        <div>
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form851"
                        perms="851"
                        title={System.getMenuTitle(851)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Gestão">
                    <Grid
                        url={'/griddocument/grid851'}
                        perms={'851'}
                        disableModal
                        clearAutoEdit
                        _useVerticalTabs
                        forceReloadAfterSave
                        GridTitle={'8.5.1 - Gerenciador de Laudos Alimentícios'}
                        GridHeaders={[
                            {
                                title: 'Gênero',
                                filter: {
                                    type: 'select',
                                    definition: subGeneros.map((sg) => {
                                        return {
                                            value: sg?._id,
                                            label: `${sg?.generoAlimento?.generoAlimento} - ${sg?.subGeneroAlimento}`
                                        };
                                    })
                                },
                                field: 'subGrupoAlimento',
                                sort: true,
                                className: 'w-2/12 text-left pl-1'
                            },
                            { title: 'Nr.Laudo', field: 'numeroLaudo', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Entrada', type: 'entrada', field: 'entrada', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Empresa', field: 'empresa', sort: true, className: 'w-4/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'REQ Laudo', field: 'reqLaudo', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Status', field: 'status', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Anexo', field: 'anexo', type: 'fileview', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                        ]}
                        LineDataPrint={(dados) => {
                            return [
                                TranslateGenero(dados.subGrupoAlimento),
                                dados.numeroLaudo,
                                dateToString(dados.entrada),
                                dados.empresa,
                                getGeneroItem(dados?.subGrupoAlimento)?.agua === true ? dados.numeroLaudo : dados.numeroRequisicaoLaudo,
                                dados.status,
                                dados.attachment
                            ];
                        }}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar Laudo' : 'Novo registro'}</span>
                                    </div>
                                    <div className='pt-2'>
                                        <GroupInput>
                                            <DropDownGroupInput
                                                name="subGrupoAlimento"
                                                label="Selecione o Gênero Alimentício"
                                                url="/genero-alimento-withsub"
                                                groupName="generoAlimento"
                                                subGroupList="subGeneros"
                                                subGroupField="subGeneroAlimento"
                                            />
                                        </GroupInput>
                                        {getGeneroItem(values?.subGrupoAlimento)?.agua === true ?
                                            <>
                                                <GroupInput>
                                                    <DateInputBR name="entrada" label="Entrada" className="w-min" />
                                                    <Input name="numeroLaudo" label="Relatório de Análise" />
                                                </GroupInput>
                                                <GroupInput>
                                                    <Input name="om" label="OM" />
                                                </GroupInput>
                                                <GroupInput>
                                                    <Input name="omEndereco" label="Endereço" />
                                                </GroupInput>
                                                <GroupInput>
                                                    <Input name="omRequisicao" label="Documento de Requisição" />
                                                </GroupInput>
                                            </>
                                            : (
                                                <>
                                                    <GroupInput>
                                                        <DateInputBR name="entrada" label="Entrada" className="w-min" />
                                                        <Input name="empresa" label="Empresa" />
                                                    </GroupInput>
                                                    <GroupInput>
                                                        <Input name="numeroLaudo" label="Número do laudo" />
                                                        <Input name="pregao" label="Pregão" />
                                                    </GroupInput>
                                                    <GroupInput>
                                                        <Input name="artigo" label="Artigo" />
                                                        <Input name="notaEmpenho" label="Nota de Empenho - NE" />
                                                    </GroupInput>
                                                    <GroupInput>
                                                        <Input name="lote" label="Lote" />
                                                        <Input name="numeroRequisicaoLaudo" label="Número da requisição do laudo" />

                                                        <Input name="nf" label="NF" />
                                                    </GroupInput>
                                                    <GroupInput>
                                                        <Input name="amostra" label="Amostra" className="w-1/2" />
                                                    </GroupInput>
                                                </>)
                                        }
                                        <GroupInput>
                                            <SelectInput
                                                name="status"
                                                label="Status"
                                                listOptions={[{ value: 'Pendente' }, { value: 'Concluído' }]}
                                                className={'w-44'}
                                            />
                                        </GroupInput>
                                    </div>
                                </div>
                            );
                        }}
                        FormTabs={[
                            (item) => "Definição do laudo",
                            (item) => "Amostras",
                            (item) => "Identificação do Artigo",
                            (item) => "Embalagem e rotulagem",
                            (item) => "Parecer",
                            (item) => {
                                return getGeneroItem(item?.subGrupoAlimento)?.agua === true ? null : "Despacho"
                            },
                            (item) => "Gerar Laudo",
                            (item) => "Anexo",
                        ]}
                        onRenderFormExtra={[
                            (GridModes, laudo, GridRefresh) => {
                                const genero = getGeneroItem(laudo?.subGrupoAlimento);
                                let generoComposicao = {};
                                if (genero?.composicao !== true) {
                                    // Coleta da Amostra
                                    return (
                                        <div className={'p-2'}>
                                            <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                <span>Laudo: {laudoAmostraTitulo(laudo)}</span>
                                            </div>
                                            <Grid
                                                url={`/griddocument/grid851-amostra-${laudo._id}`}
                                                perms={'851'}
                                                disableModal={true}
                                                showCSVExport={false}
                                                showPDFExport={false}
                                                useVerticalTabs
                                                title="Amostras Coletadas"
                                                GridHeaders={[
                                                    { title: 'Data', field: 'dataAmostra', sort: true, className: 'w-1/6 text-left pl-1' },
                                                    { title: 'Termo Coleta', field: 'termoAmostra', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Quantidade', field: 'quantiaAmostra', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Responsável', field: 'responsavelAmostra', sort: false, className: 'w-3/6 pl-1 text-left border-l border-gray-300' },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [dateToString(data.dataAmostra), data.termoAmostra, data.quantiaAmostra, data.responsavelAmostra];
                                                }}
                                                onRenderForm={() => {
                                                    return (
                                                        <div className="w-full">
                                                            <GroupInput>
                                                                <DateInputBR label="Data da Coleta" name="dataAmostra" />
                                                                <Input label="Termo da Coleta" name="termoAmostra" />
                                                                <Input label="Quantia coletada" name="quantiaAmostra" />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <Input label="Local" name="localColetaAmostra" />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <Input label="Responsável" name="responsavelAmostra" />
                                                            </GroupInput>
                                                        </div>
                                                    );
                                                }}
                                                validationSchema={() => {
                                                    return yup.object().shape({
                                                        dataAmostra: yup.date(),
                                                        termoAmostra: yup.string(),
                                                        responsavelAmostra: yup.string(),
                                                    });
                                                }}
                                                FormTabs={[
                                                    (item) => "Amostra",
                                                    (item) => genero?.microbiologico && "Critério microbiológico",
                                                    (item) => genero?.analiseMicrobiologica && "Análise Microbiológica",
                                                    (item) => genero?.fisicoQuimico && "Critério físico-químico",
                                                    (item) => genero?.organoleptico && "Características organolépticas",
                                                    (item) => genero?.microscopico && "Critério microscópico",
                                                    //(item) => genero?.laboratorial && "Análise laboratorial",
                                                    (item) => genero?.bebida && "Qualidade global da bebida",
                                                    (item) => genero?.merceologico && "Classificação merceológica",
                                                    (item) => genero?.macroscopico && "Análise macroscópica",
                                                    (item) => genero?.classificatorio && "Classificação do produto",
                                                ]}
                                                onRenderFormExtra={[
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Critério microbiológico
                                                        return (
                                                            <div className='pt-2'>
                                                                <Tabs
                                                                    className="w-full"
                                                                    type="card"
                                                                    items={[
                                                                        {
                                                                            label: "Método utilizado",
                                                                            key: uuidv4(),
                                                                            children: (
                                                                                <FormInput
                                                                                    document={`/griddocument/grid851-amostra-${laudo._id}/${amostra._id}`}
                                                                                    perms={'851'}
                                                                                    onRenderFields={(setFieldValue, values) => {
                                                                                        return (
                                                                                            <div>
                                                                                                <GroupInput>
                                                                                                    <Input name="microbiologicoMetodo" label="Método" className="w-full" />
                                                                                                </GroupInput>
                                                                                            </div>
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            )
                                                                        },
                                                                        {
                                                                            label: "Ensaios",
                                                                            key: uuidv4(),
                                                                            children: (
                                                                                <Grid
                                                                                    url={`/griddocument/grid851-amostra-${laudo._id}-microbiologico-${amostra._id}`}
                                                                                    perms={'851'}
                                                                                    disableModal={true}
                                                                                    showCSVExport={false}
                                                                                    showPDFExport={false}
                                                                                    GridHeaders={
                                                                                        genero.agua ?
                                                                                            [
                                                                                                { title: 'Microorganismos/Ensaio', field: 'categoria', sort: true, className: 'w-2/6 text-left pl-1' },
                                                                                                { title: 'Análise', field: 'analise', type: "date", sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Resultado', field: 'resultado', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Padrão', field: 'padrao', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                                            ]
                                                                                            :
                                                                                            [
                                                                                                { title: 'Microorganismos/Ensaio', field: 'categoria', sort: true, className: 'w-2/12 text-left pl-1' },
                                                                                                { title: 'n', field: 'n', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'c', field: 'c', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'm', field: 'm', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'M', field: 'mm', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Análise', field: 'analise', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Resultado', field: 'resultado', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Padrão', field: 'padrao', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                                                            ]}
                                                                                    LineDataPrint={(data) => {
                                                                                        if (genero.agua) return [data.microorganismos, dateToString(data.analise), data.resultado, data.padrao];
                                                                                        return [
                                                                                            data.microorganismos,
                                                                                            data.n,
                                                                                            data.c,
                                                                                            data.m,
                                                                                            data.mm,
                                                                                            data.analise,
                                                                                            data.resultado,
                                                                                            data.padrao
                                                                                        ];


                                                                                    }}
                                                                                    onRenderForm={() => {
                                                                                        return (
                                                                                            <div className="w-full">
                                                                                                <GroupInput>
                                                                                                    <Input label="Microorganismos/Ensaio" name="microorganismos" />
                                                                                                </GroupInput>
                                                                                                {!genero.agua &&
                                                                                                    <GroupInput>
                                                                                                        <Input label="n" name="n" />
                                                                                                        <Input label="c" name="c" />
                                                                                                        <Input label="m" name="m" />
                                                                                                        <Input label="M" name="mm" />
                                                                                                    </GroupInput>
                                                                                                }
                                                                                                <GroupInput>
                                                                                                    <Input label="Análise" name="analise" />
                                                                                                </GroupInput>
                                                                                                <GroupInput>
                                                                                                    <Input label="Resultado" name="resultado" />
                                                                                                </GroupInput>
                                                                                                {genero.agua &&
                                                                                                    <GroupInput>
                                                                                                        <Input label="Padrão" name="padrao" />
                                                                                                    </GroupInput>
                                                                                                }
                                                                                            </div>
                                                                                        );
                                                                                    }}
                                                                                    validationSchema={() => {
                                                                                        return yup.object().shape({
                                                                                            microorganismos: yup.string(),
                                                                                            analise: yup.string(),
                                                                                            resultado: yup.string(),
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            )
                                                                        }

                                                                    ]}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Análise Microbiológica
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Análise Microbiológica</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <TextInput name="analiseMicrobiologicaDetalhamento" label="Detalhamento" className="w-full" rows="8" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div >
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Critério físico-químico
                                                        return (
                                                            <div>
                                                                <Grid
                                                                    url={`/griddocument/grid851-amostra-${laudo._id}-fisicoQuimico-${amostra._id}`}
                                                                    perms={'851'}
                                                                    disableModal
                                                                    showCSVExport={false}
                                                                    showPDFExport={false}
                                                                    GridHeaders={[
                                                                        { title: 'Determinação', field: 'determinacao', sort: true, className: 'w-1/3 text-left pl-1' },
                                                                        { title: 'Análise', field: 'analise', sort: true, className: 'w-1/3 pl-1 text-left border-l border-gray-300' },
                                                                        { title: 'Padrão', field: 'padrao', sort: true, className: 'w-1/3 pl-1 text-left border-l border-gray-300' },
                                                                    ]}
                                                                    LineDataPrint={(dados) => {
                                                                        return [dados.determinacao, dados.analise, dados.padrao];
                                                                    }}
                                                                    onRenderForm={() => {
                                                                        return (
                                                                            <div>
                                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                                    <span>Critérios</span>
                                                                                </div>

                                                                                <GroupInput>
                                                                                    <Input label="Determinação" name="determinacao" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Análise" name="analise" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Padrão" name="padrao" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                    validationSchema={() => {
                                                                        return yup.object().shape({
                                                                            determinacao: yup.string(),
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Caracteristicas Organolepticas
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Caracteristicas Organolépticas</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <SelectInput
                                                                                        name="caracteristicasOrganolepticas"
                                                                                        label="Características organolépticas"
                                                                                        className={"w-2/6"}
                                                                                        listOptions={[{ value: 'Sem alteração' }, { value: 'Com alteração' }, { value: 'Não aplicável' }]}
                                                                                    />
                                                                                    <Input name="caracteristicasOrganolepticasObservacao" label="Observação" className={"w-4/6"} />

                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Critério microscópico
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Apresenta Critério Microscópicos</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <TextInput name="microscopicoDetalhamento" label="Detalhamento" className="w-full" rows="8" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div >
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Caracteristicas Global da Bebida
                                                        return (
                                                            <div className={'mt-2'}>
                                                                <Grid
                                                                    url={`/griddocument/grid851-amostra-${laudo._id}-bebida-${amostra._id}`}
                                                                    perms={'851'}
                                                                    disableModal={true}
                                                                    showCSVExport={false}
                                                                    showPDFExport={false}
                                                                    GridHeaders={[
                                                                        { title: 'Categoria', field: 'categoria', sort: true, className: 'w-4/6 text-left pl-1' },
                                                                        { title: 'Resultado', field: 'resultado', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                        { title: 'Padrão', field: 'padrao', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                    ]}
                                                                    LineDataPrint={(data) => {
                                                                        return [data.categoria, data.resultado, data.padrao];
                                                                    }}
                                                                    onRenderForm={() => {
                                                                        return (
                                                                            <div className="w-full">
                                                                                <GroupInput>
                                                                                    <Input label="Categoria" name="categoria" />
                                                                                    <Input label="Resultado" name="resultado" />
                                                                                    <Input label="Padrão" name="padrao" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                    validationSchema={() => {
                                                                        return yup.object().shape({
                                                                            categoria: yup.string(),
                                                                            resultado: yup.string(),
                                                                            padrao: yup.string(),
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Classificação merceológica
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Classificação merceológica</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <Input label="Classe" name="classe" />
                                                                                    <Input label="Tipo" name="tipo" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Certificado de classificação" name="certificadoClassificacaoMerceologico" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Análise macroscópica
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Análise macroscópica</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <TextInput name="macroscopicoDetalhamento" label="Detalhamento" className="w-full" rows="8" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Classificação do produto
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Classificação do produto</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <Input label="Grupo" name="grupo" />
                                                                                    <Input label="Classe" name="classe" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="SubGrupo" name="subgrupo" />
                                                                                    <Input label="Tipo" name="tipo" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Certificado de classificação" name="certificadoClassificacaoProduto" />
                                                                                </GroupInput>

                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },


                                                ]}
                                            />
                                        </div>
                                    )
                                } else {
                                    // Coleta da amostra - Composição
                                    return (
                                        <div className={'p-2'}>
                                            <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                <span>Laudo: {laudoAmostraTitulo(laudo)}</span>
                                            </div>
                                            <Grid
                                                url={`/griddocument/grid851-amostra-composicao-${laudo._id}`}
                                                perms={'851'}
                                                disableModal={true}
                                                showCSVExport={false}
                                                showPDFExport={false}
                                                useVerticalTabs
                                                title="Amostras Coletadas"
                                                GridHeaders={[
                                                    { title: 'Item', field: 'subGrupoAlimento', sort: true, className: 'w-6/12 text-left pl-1' },
                                                    { title: 'Termo Coleta', field: 'termoAmostra', sort: true, className: 'w-1/12 text-left pl-1 border-l border-gray-300' },
                                                    { title: 'Lote', field: 'lote', sort: true, className: 'w-1/12 text-left pl-1 border-l border-gray-300' },
                                                    { title: 'Fabricação', field: 'fabricacao', type: 'date', sort: true, className: 'w-1/12 text-left pl-1 border-l border-gray-300' },
                                                    { title: 'Validade', field: 'validade', type: 'date', sort: true, className: 'w-1/12 text-left pl-1 border-l border-gray-300' },
                                                    { title: 'Peso líquido', field: 'pesoLiquido', sort: true, className: 'w-1/12 text-center pl-1 border-l border-gray-300' },
                                                    { title: 'Padrão', field: 'padrao', sort: true, className: 'w-1/12 text-center pl-1 border-l border-gray-300' },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [
                                                        getGeneroItem(data.subGrupoAlimento)?.subGeneroAlimento ?? '',
                                                        data.termoAmostra,
                                                        data.lote,
                                                        dateToString(data.fabricacao),
                                                        dateToString(data.validade),
                                                        data.pesoLiquido,
                                                        data.padrao
                                                    ];
                                                }}
                                                onSelectItem={(item) => {
                                                    generoComposicao = getGeneroItem(item?.subGrupoAlimento);
                                                }}
                                                onRenderForm={(GridModes, setFieldValue, values) => {
                                                    return (
                                                        <div className="w-full">
                                                            <GroupInput>
                                                                <DBSelectInput
                                                                    name="subGrupoAlimento"
                                                                    label="Selecione o item"
                                                                    url={`/sub-genero-alimento/${getGeneroItem(laudo?.subGrupoAlimento)?.generoAlimento?._id}`}
                                                                    displaySelectField={'subGeneroAlimento'}
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <Input label="Termo da Coleta" name="termoAmostra" />
                                                                <Input name="lote" label="Lote" />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <DateInputBR name="fabricacao" label="Fabricação" />
                                                                <DateInputBR name="validade" label="Validade" />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <Input name="pesoLiquido" label="Peso líquido" />
                                                                <Input name="padrao" label="Padrão" />
                                                            </GroupInput>

                                                        </div>
                                                    );
                                                }}
                                                validationSchema={() => {
                                                    return yup.object().shape({
                                                        subGrupoAlimento: yup.string(),
                                                    });
                                                }}
                                                FormTabs={[
                                                    (item) => "Amostra",
                                                    (item) => generoComposicao?.microbiologico && "Critério microbiológico",
                                                    (item) => generoComposicao?.analiseMicrobiologica && "Análise Microbiológica",
                                                    (item) => generoComposicao?.fisicoQuimico && "Critério físico-químico",
                                                    (item) => generoComposicao?.organoleptico && "Características organolépticas",
                                                    (item) => generoComposicao?.microscopico && "Critério microscópico",
                                                    (item) => generoComposicao?.bebida && "Qualidade global da bebida",
                                                    (item) => generoComposicao?.merceologico && "Classificação merceológica",
                                                    (item) => generoComposicao?.macroscopico && "Análise macroscópica",
                                                    (item) => generoComposicao?.classificatorio && "Classificação do produto",
                                                ]}
                                                onRenderFormExtra={[
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Critério microbiológico - Composição
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>

                                                                <Tabs
                                                                    className="w-full"
                                                                    type="card"
                                                                    items={[
                                                                        {
                                                                            label: "Método utilizado",
                                                                            key: uuidv4(),
                                                                            children: (
                                                                                <FormInput
                                                                                    document={`/griddocument/grid851-amostra-composicao-${laudo._id}/${amostra._id}`}
                                                                                    perms={'851'}
                                                                                    onRenderFields={(setFieldValue, values) => {
                                                                                        return (
                                                                                            <div>
                                                                                                <GroupInput>
                                                                                                    <Input name="microbiologicoMetodo" label="Método" className="w-full" />
                                                                                                </GroupInput>
                                                                                            </div>
                                                                                        );
                                                                                    }}
                                                                                />
                                                                            )
                                                                        },
                                                                        {
                                                                            label: "Ensaios",
                                                                            key: uuidv4(),
                                                                            children: (
                                                                                <Grid
                                                                                    url={`/griddocument/grid851-amostra-composicao-${laudo._id}-microbiologico-${amostra._id}`}
                                                                                    perms={'851'}
                                                                                    disableModal={true}
                                                                                    showCSVExport={false}
                                                                                    showPDFExport={false}
                                                                                    GridHeaders={
                                                                                        genero.agua ?
                                                                                            [
                                                                                                { title: 'Microorganismos/Ensaio', field: 'categoria', sort: true, className: 'w-2/6 text-left pl-1' },
                                                                                                { title: 'Análise', field: 'analise', type: "date", sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Resultado', field: 'resultado', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Padrão', field: 'padrao', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                                            ]
                                                                                            :
                                                                                            [
                                                                                                { title: 'Microorganismos/Ensaio', field: 'categoria', sort: true, className: 'w-2/12 text-left pl-1' },
                                                                                                { title: 'n', field: 'n', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'c', field: 'c', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'm', field: 'm', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'M', field: 'mm', sort: false, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Análise', field: 'analise', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Resultado', field: 'resultado', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                                                                { title: 'Padrão', field: 'padrao', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                                                            ]}
                                                                                    LineDataPrint={(data) => {
                                                                                        if (genero.agua) return [
                                                                                            data.microorganismos,
                                                                                            dateToString(data.analise),
                                                                                            data.resultado,
                                                                                            data.padrao
                                                                                        ];
                                                                                        return [
                                                                                            data.microorganismos,
                                                                                            data.n,
                                                                                            data.c,
                                                                                            data.m,
                                                                                            data.mm,
                                                                                            data.analise,
                                                                                            data.resultado,
                                                                                            data.padrao
                                                                                        ];
                                                                                    }}
                                                                                    onRenderForm={() => {
                                                                                        return (
                                                                                            <div className="w-full">
                                                                                                <GroupInput>
                                                                                                    <Input label="Microorganismos/Ensaio" name="microorganismos" />
                                                                                                </GroupInput>
                                                                                                {!genero.agua &&
                                                                                                    <GroupInput>
                                                                                                        <Input label="n" name="n" />
                                                                                                        <Input label="c" name="c" />
                                                                                                        <Input label="m" name="m" />
                                                                                                        <Input label="M" name="mm" />
                                                                                                    </GroupInput>
                                                                                                }
                                                                                                <GroupInput>
                                                                                                    <Input label="Análise" name="analise" />
                                                                                                </GroupInput>
                                                                                                <GroupInput>
                                                                                                    <Input label="Resultado" name="resultado" />
                                                                                                </GroupInput>
                                                                                                {genero.agua &&
                                                                                                    <GroupInput>
                                                                                                        <Input label="Padrão" name="padrao" />
                                                                                                    </GroupInput>
                                                                                                }
                                                                                            </div>
                                                                                        );
                                                                                    }}
                                                                                    validationSchema={() => {
                                                                                        return yup.object().shape({
                                                                                            microorganismos: yup.string(),
                                                                                            analise: yup.string(),
                                                                                            resultado: yup.string(),
                                                                                        });
                                                                                    }}
                                                                                />
                                                                            )
                                                                        }
                                                                    ]}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Análise Microbiológica - Composição
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-composicao-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <TextInput name="analiseMicrobiologicaDetalhamento" label="Detalhamento" className="w-full" rows="8" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div >
                                                        );
                                                    },

                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Critério físico-químico - Composição
                                                        return (
                                                            <div>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>
                                                                <Grid
                                                                    url={`/griddocument/grid851-amostra-composicao-${laudo._id}-fisicoQuimico-${amostra._id}`}
                                                                    perms={'851'}
                                                                    disableModal
                                                                    showCSVExport={false}
                                                                    showPDFExport={false}
                                                                    GridHeaders={[
                                                                        { title: 'Determinação', field: 'determinacao', sort: true, className: 'w-1/3 text-left pl-1' },
                                                                        { title: 'Análise', field: 'analise', sort: true, className: 'w-1/3 pl-1 text-left border-l border-gray-300' },
                                                                        { title: 'Padrão', field: 'padrao', sort: true, className: 'w-1/3 pl-1 text-left border-l border-gray-300' },
                                                                    ]}
                                                                    LineDataPrint={(dados) => {
                                                                        return [dados.determinacao, dados.analise, dados.padrao];
                                                                    }}
                                                                    onRenderForm={() => {
                                                                        return (
                                                                            <div>
                                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                                    <span>Critérios</span>
                                                                                </div>
                                                                                <GroupInput>
                                                                                    <Input label="Determinação" name="determinacao" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Análise" name="analise" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Padrão" name="padrao" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                    validationSchema={() => {
                                                                        return yup.object().shape({
                                                                            determinacao: yup.string(),
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Caracteristicas Organolepticas - Composição
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-composicao-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <SelectInput
                                                                                        name="caracteristicasOrganolepticas"
                                                                                        label="Características organolépticas"
                                                                                        className={"w-2/6"}
                                                                                        listOptions={[{ value: 'Sem alteração' }, { value: 'Com alteração' }, { value: 'Não aplicável' }]}
                                                                                    />
                                                                                    <Input name="caracteristicasOrganolepticasObservacao" label="Observação" className={"w-4/6"} />

                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Critério microscópico - Composição
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-composicao-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <TextInput name="microscopicoDetalhamento" label="Detalhamento" className="w-full" rows="8" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div >
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Caracteristicas Global da Bebida - Composição
                                                        return (
                                                            <div className={'mt-2'}>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>
                                                                <Grid
                                                                    url={`/griddocument/grid851-amostra-composicao-${laudo._id}-bebida-${amostra._id}`}
                                                                    perms={'851'}
                                                                    disableModal={true}
                                                                    showCSVExport={false}
                                                                    showPDFExport={false}
                                                                    GridHeaders={[
                                                                        { title: 'Categoria', field: 'categoria', sort: true, className: 'w-4/6 text-left pl-1' },
                                                                        { title: 'Resultado', field: 'resultado', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                        { title: 'Padrão', field: 'padrao', sort: false, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                                                                    ]}
                                                                    LineDataPrint={(data) => {
                                                                        return [data.categoria, data.resultado, data.padrao];
                                                                    }}
                                                                    onRenderForm={() => {
                                                                        return (
                                                                            <div className="w-full">
                                                                                <GroupInput>
                                                                                    <Input label="Categoria" name="categoria" />
                                                                                    <Input label="Resultado" name="resultado" />
                                                                                    <Input label="Padrão" name="padrao" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                    validationSchema={() => {
                                                                        return yup.object().shape({
                                                                            categoria: yup.string(),
                                                                            resultado: yup.string(),
                                                                            padrao: yup.string(),
                                                                        });
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Classificação merceológica - Composição
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>

                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-composicao-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <Input label="Classe" name="classe" />
                                                                                    <Input label="Tipo" name="tipo" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Certificado de classificação" name="certificadoClassificacaoMerceologico" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Análise macroscópica - Composição
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-composicao-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <TextInput name="macroscopicoDetalhamento" label="Detalhamento" className="w-full" rows="8" />
                                                                                </GroupInput>
                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                    (GridModes, amostra, GridRefresh) => {
                                                        // Classificação do produto - Composição
                                                        return (
                                                            <div className='pt-2'>
                                                                <div className="inline-flex w-full h-10 p-2 mb-2 text-gray-800 bg-gray-100 border border-gray-300 rounded-md x-2">
                                                                    <span>{generoComposicao.subGeneroAlimento}</span>
                                                                </div>
                                                                <FormInput
                                                                    document={`/griddocument/grid851-amostra-composicao-${laudo._id}/${amostra._id}`}
                                                                    perms={'851'}
                                                                    onRenderFields={(setFieldValue, values) => {
                                                                        return (
                                                                            <div>
                                                                                <GroupInput>
                                                                                    <Input label="Grupo" name="grupo" />
                                                                                    <Input label="Classe" name="classe" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="SubGrupo" name="subgrupo" />
                                                                                    <Input label="Tipo" name="tipo" />
                                                                                </GroupInput>
                                                                                <GroupInput>
                                                                                    <Input label="Certificado de classificação" name="certificadoClassificacaoProduto" />
                                                                                </GroupInput>

                                                                            </div>
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    },
                                                ]}
                                            />
                                        </div>
                                    )

                                }
                            },
                            (GridModes, laudo, GridRefresh) => {
                                // Identificacao do Artigo
                                return (
                                    <div className='pt-2'>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>Identificação do Artigo</span>
                                        </div>
                                        <div className="inline-flex w-full">
                                            <div className='w-1/2'>
                                                <FormInput
                                                    document={`/griddocument/grid851/${laudo._id}`}
                                                    perms={'851'}
                                                    onRenderFields={(setFieldValue, values) => {
                                                        return (
                                                            <div>
                                                                <GroupInput>
                                                                    <Input name="fabricante" label="Fabricante" className="w-1/2" />
                                                                    <Input name="marca" label="Marca" />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <Input name="cnpj" label="CNPJ" className="w-1/2" />
                                                                    <Input name="numeroLote" label="Número do Lote" />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <Input name="sif" label="Serviço de Inspeção Federal - SIF" />
                                                                </GroupInput>

                                                            </div>
                                                        );
                                                    }}
                                                />
                                            </div>
                                            <div className='w-1/2 mt-2'>
                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left ">
                                                    <span>Fabricação e Validade</span>
                                                </div>
                                                <Grid
                                                    url={`/griddocument/grid851-artigoValidades-${laudo._id}`}
                                                    perms={'851'}

                                                    showCSVExport={false}
                                                    showPDFExport={false}
                                                    GridHeaders={[
                                                        { title: 'Fabricação', field: 'fabricacao', type: 'date', sort: true, className: 'w-1/2 text-left pl-1' },
                                                        { title: 'Validade', field: 'validade', type: 'date', sort: true, className: 'w-1/2 pl-1 text-left border-l border-gray-300' },
                                                    ]}
                                                    LineDataPrint={(dados) => {
                                                        return [dateToString(dados.fabricacao), dateToString(dados.validade)];
                                                    }}
                                                    onRenderForm={() => {
                                                        return (
                                                            <div>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Datas relacionadas</span>
                                                                </div>

                                                                <GroupInput>
                                                                    <DateInputBR label="Fabricação" name="fabricacao" />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <DateInputBR label="Validade" name="validade" />
                                                                </GroupInput>
                                                            </div>
                                                        );
                                                    }}
                                                    validationSchema={() => {
                                                        return yup.object().shape({
                                                            fabricacao: yup.date(),
                                                            valide: yup.date(),
                                                        });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            },
                            (GridModes, laudo, GridRefresh) => {
                                // Embalagem e Rotulagem
                                const genero = getGeneroItem(laudo?.subGrupoAlimento);
                                return (
                                    <div className='pt-2'>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>Embalagem e Rotulagem</span>
                                        </div>
                                        <FormInput
                                            document={`/griddocument/grid851/${laudo._id}`}
                                            perms={'851'}
                                            onRenderFields={(setFieldValue, values) => {
                                                return (
                                                    <div>
                                                        <GroupInput>
                                                            <Input name="embalagemPrimaria" label="Embalagem Primária" />
                                                            <SelectInput name="rotulagem" label="Rotulagem" listOptions={[{ value: 'Aprovada' }, { value: 'Reprovada' }]} />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <Input name="embalagemSecundaria" label="Embalagem Secundária" />
                                                            <SelectInput name="conteudoLiquido" label="Conteúdo Líquido" listOptions={[{ value: 'Aprovada' }, { value: 'Reprovada' }]} />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <TextInput name="embalagemObservacoes" label="Observações" rows="5" />
                                                        </GroupInput>
                                                        {genero?.composicao === true && (
                                                            <div className='mt-2'>
                                                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                                                    <span>Exame de conteúdo</span>
                                                                </div>
                                                                <GroupInput>
                                                                    <Input name="embalagemLiquidoExame" label="Conteúdo líquido" />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <Input name="embalagemAcessoriosExame" label="Acessórios" />
                                                                </GroupInput>
                                                            </div>
                                                        )}
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                );
                            },

                            (GridModes, laudo, GridRefresh) => {
                                // Parecer
                                return (
                                    <div className='pt-2'>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>Parecer</span>
                                        </div>
                                        <FormInput
                                            document={`/griddocument/grid851/${laudo._id}`}
                                            perms={'851'}
                                            onRenderFields={(setFieldValue, values) => {
                                                return (
                                                    <div>
                                                        <GroupInput>
                                                            <TextInput name="parecerDetalhamento" label="Detalhamento" className="w-full" rows="6" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <SelectInput
                                                                name="parecerStatus"
                                                                label="Status Parecer"
                                                                className={'w-1/6'}
                                                                listOptions={[
                                                                    { value: 'Atende' },
                                                                    { value: 'Não Atende' }
                                                                ]}
                                                            />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <TextInput name="parecerMotivoRejeicao" label="Motivo da Rejeição" className="w-full" rows="6" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <TextInput name="parecerObservacao" label="Observações finais" className="w-full" rows="6" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <Input name="parecerLocal" label="Local" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <DateInputBR name="parecerDataEmissao" label="Data Emissão" className="w-min" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <DateInputBR name="parecerPrazoLaudo" label="Prazo validade do Laudo" className="w-min" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <Input name="parecerResponsavel" label="Responsável" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <Input name="parecerResponsavelFuncao" label="Função do Responsável" />
                                                        </GroupInput>
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                );
                            },
                            (GridModes, laudo, GridRefresh) => {
                                // Despacho
                                return (
                                    <div className='pt-2'>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>Despacho</span>
                                        </div>
                                        <FormInput
                                            document={`/griddocument/grid851/${laudo._id}`}
                                            perms={'851'}
                                            onRenderFields={(setFieldValue, values) => {
                                                return (
                                                    <div>
                                                        <GroupInput>
                                                            <SelectInput
                                                                name="despachoConcordo"
                                                                label="Com o parecer do inspecionador"
                                                                className="w-1/3"
                                                                listOptions={[
                                                                    { value: 'Concordo' },
                                                                    { value: 'Não concordo' },
                                                                ]}
                                                            />

                                                        </GroupInput>
                                                        <GroupInput>
                                                            <SelectInput
                                                                name="despachoArtigoRecusado"
                                                                label="Recepção do artigo, o mesmo deve ser:"
                                                                className="w-1/3"
                                                                listOptions={[
                                                                    { value: 'Recebido' },
                                                                    { value: 'Recusado' },
                                                                ]}
                                                            />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <SelectInput
                                                                name="despachoNotificarFornecedor"
                                                                label="Fornecedor deve ser notificado?"
                                                                className="w-1/3"
                                                                listOptions={[
                                                                    { value: 'Sim' },
                                                                    { value: 'Não' },
                                                                ]}
                                                            />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <SelectInput
                                                                name="despachoNotificarFiscalizacao"
                                                                label="Notificar orgão fiscalizador competente?"
                                                                className="w-1/3"
                                                                listOptions={[
                                                                    { value: 'Sim' },
                                                                    { value: 'Não' },
                                                                ]}
                                                            />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <TextInput name="despachoJustificativa" label="Justificativa" className="w-full" rows="6" information="Quando o artigo estiver fora de conformidade com os Padrões de Identidade e Qualidade previstos no Boletim Técnico de Especificação Técnica de Artigo de Subsistência e/ou em desacordo com a Legislação oficial." />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <Input name="despachoResponsavel" label="Responsável" />
                                                        </GroupInput>
                                                        <GroupInput>
                                                            <Input name="despachoResponsavelFuncao" label="Função do Responsável" />
                                                        </GroupInput>

                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                );
                            },
                            (GridModes, laudoGrid, GridRefresh) => {
                                const dadosLaudo = {
                                    // Cabeçalho
                                    orgao: {
                                        linha1: 'MINISTÉRIO DA DEFESA',
                                        linha2: 'EXÉRCITO BRASILEIRO',
                                        linha3: '7º DEPÓSITO DE SUPRIMENTO',
                                        linha4: '" DEPÓSITO CAMPINA DO TABORDA "'
                                    },

                                    // Identificação
                                    numeroRelatorio: '001/2025',
                                    om: '4º Batalhão de Polícia do Exército',
                                    endereco: 'Rodovia BR-232 km 6 | Recife - PE | CEP:, Recife - PE, 50950-000',
                                    documentoRequisicao: {
                                        linha1: 'DIEx DIEx nº 3593-Aprov/4º BPE, de 3 de outubro de 2025, do Comandante do 4º Batalhão de Polícia',
                                        linha2: 'do Exército'
                                    },

                                    // Amostras coletadas
                                    amostras: [
                                        {
                                            dataHora: '18 de novembro de 2025',
                                            pontoColeta: 'torneira de lavagem de horifrutigranjeiros',
                                            responsavel: '2º Ten OVT JULLYANE PALITOT',
                                            metodo: 'Cromogênico fluorogênico (MUG)',
                                            ensaios: [
                                                { nome: 'Coliformes totais', resultado: 'Aus', padrao: 'Ausência em 100 mL' },
                                                { nome: 'Escherichia coli/g', resultado: 'Aus', padrao: 'Ausência em 100 mL', italico: true }
                                            ]
                                        },
                                        {
                                            dataHora: '18 de novembro de 2025',
                                            pontoColeta: 'filtro da maquina de gelo',
                                            responsavel: '2º Ten OVT JULLYANE PALITOT',
                                            metodo: 'Cromogênico fluorogênico (MUG)',
                                            ensaios: [
                                                { nome: 'Coliformes totais', resultado: 'Aus', padrao: 'Ausência em 100 mL' },
                                                { nome: 'Escherichia coli/g', resultado: 'Aus', padrao: 'Ausência em 100 mL', italico: true }
                                            ]
                                        },
                                        {
                                            dataHora: '18 de novembro de 2025',
                                            pontoColeta: 'torneira conecta ao poço da OM.',
                                            responsavel: '2º Ten OVT JULLYANE PALITOT',
                                            metodo: 'Cromogênico fluorogênico (MUG)',
                                            ensaios: [
                                                { nome: 'Coliformes totais', resultado: 'Aus', padrao: 'Ausência em 100 mL' },
                                                { nome: 'Escherichia coli/g', resultado: 'Aus', padrao: 'Ausência em 100 mL', italico: true }
                                            ]
                                        }
                                    ],

                                    // Parecer
                                    parecer: 'Em CONFORMIDADE com os parâmetros microbiológicos apresentados no Anexo I da Portaria GM/MS Nº 888, de 4 de maio de 2021, do Ministério da Saúde, que dispõe sobre o padrão bacteriológico da água para consumo humano.',

                                    // Observação
                                    observacao: 'O resultado desta análise tem significado restrito e se aplica tão somente às amostras analisadas.',

                                    // Rodapé
                                    local: 'Quartel em Recife - PE',
                                    data: '03/12/2025',

                                    // Assinatura
                                    assinatura: {
                                        nome: 'JULLYANE PONTES PALITOT',
                                        posto: '2º TEN OVT',
                                        funcao: 'Chefe e Inspetora do LIAB'
                                    }
                                };

                                // Gerar Laudo
                                return (
                                    <div className='pt-2'>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>Emissão do Laudo</span>
                                        </div>
                                        <button className="flex px-4 py-2 mt-4 ml-4 font-bold rounded bg-amarelo-eq hover:bg-blue-700" onClick={
                                            () => {
                                                System.apiGet(`/griddocument/grid851/${laudoGrid._id}`).then((response) => {
                                                    if (response.status === 200) {
                                                        // Buscar laudo atual no DB (evitar usar dados não salvos)
                                                        let laudo = response.data;
                                                        const genero = getGeneroItem(laudo?.subGrupoAlimento);
                                                        //console.log("laudo", laudo);

                                                        Laudo851(laudo, genero, dadosLaudo);
                                                    }
                                                })
                                            }
                                        }>
                                            Gerar Laudo
                                        </button>

                                    </div>
                                );
                            },
                            (GridModes, laudo, GridRefresh) => {
                                // Anexo
                                return (
                                    <div className='pt-2'>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>Anexo</span>
                                        </div>
                                        <FormInput
                                            document={`/griddocument/grid851/${laudo._id}`}
                                            perms={'851'}
                                            onRenderFields={(setFieldValue, values) => {
                                                return (
                                                    <div>
                                                        <GroupInput>
                                                            <AttachmentInput
                                                                name="attachment"
                                                                perms="851"
                                                                label="Anexo"
                                                            />
                                                        </GroupInput>
                                                    </div>
                                                );
                                            }}
                                        />
                                    </div>
                                );
                            },


                        ]}


                        onBeforeDelete={async (item) => {
                            //await System.apiDelete('/griddocument/grid853-' + item._id);
                            //await System.apiDelete('/griddocument/grid853-foto-' + item._id);
                            //await System.apiDelete('/griddocument/grid853-higienizacao-' + item._id);
                            //await System.apiDelete('/griddocument/grid853-estanqueidade-' + item._id);
                            //await System.apiDelete('/griddocument/grid853-hidrostatico-' + item._id);
                            //await System.apiDelete('/griddocument/grid853-carga-' + item._id);
                        }}
                        validationSchema={
                            yup.object().shape({
                                subGrupoAlimento: yup.string().required(),
                            })
                        }
                    />

                </TabPanel >
            </TabsInput >
        </div >
    );
};

export const Form851 = () => {
    const System = useSystemContext();
    const [empresa, setEmpresa] = useState({});
    useEffect(() => {
        System.methods.getCompany().then(setEmpresa);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!empresa) return null;

    return empresa?.controleLaudos851
        ? (<Form851Laudos System={System} empresa={empresa} />)
        : (<Form851Normal System={System} empresa={empresa} />);
}

export const Form852 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão I</span>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão R</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form852"
                        perms="852"
                        title={System.getMenuTitle(852)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Identificação">
                    <Grid
                        url={'/griddocument/grid852_identificacao'}
                        perms={'852'}
                        GridHeaders={[
                            { title: 'Descrição', field: 'descricao', sort: true, className: 'w-5/6 text-left pl-1' },
                            { title: 'Etapa', field: 'etapa', sort: true, className: 'w-1/6 text-left border-l border-gray-300' },
                        ]}
                        LineDataPrint={(data) => {
                            return [data.descricao, data.etapa];
                        }}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <Input name="descricao" label="Descrição" />
                                    <Input name="etapa" label="Etapa" />
                                    <Input name="situacao" label="Situação" />
                                    <Input name="controle" label="Controle" />
                                </div>
                            );
                        }}
                        validationSchema={yup.object().shape({
                            descricao: yup.string().required(),
                            etapa: yup.string(),
                            situacao: yup.string(),
                            controle: yup.string(),
                        })}
                    />
                </TabPanel>
                <TabPanel name="Rastreabilidade">
                    <Grid
                        url={'/griddocument/grid852_rastreabilidade'}
                        perms={'852'}
                        GridHeaders={[
                            { title: 'Descrição', field: 'descricao', sort: true, className: 'w-5/6 text-left pl-1' },
                            { title: 'Etapa', field: 'etapa', sort: true, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                        ]}
                        LineDataPrint={(data) => {
                            return [data.descricao, data.etapa];
                        }}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editarndo' : 'Novo registro'}</span>
                                    </div>
                                    <Input name="descricao" label="Descrição" />
                                    <Input name="etapa" label="Etapa" />
                                    <Input name="situacao" label="Situação" />
                                    <Input name="controle" label="Controle" />
                                </div>
                            );
                        }}
                        validationSchema={yup.object().shape({
                            descricao: yup.string().required(),
                            etapa: yup.string(),
                            situacao: yup.string(),
                            controle: yup.string(),
                        })}
                    />
                </TabPanel>
            </TabsInput>
        </div>
    );
};


const Form853Normal = ({ System, empresa }) => {
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form853"
                        perms="853"
                        title={System.getMenuTitle(853)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Gestão">
                    <Grid
                        url={'/griddocument/grid853'}
                        url_get_all={'/griddocumentcustomers/grid853'}
                        perms={'853'}
                        disableModal={true}
                        clearAutoEdit={true}
                        forceReloadAfterSave={true}
                        GridTitle={'8.5.3 - Propriedade do cliente ou Provedor Externo'}
                        GridHeaders={[
                            { title: 'Descrição', field: 'descricao', sort: true, className: 'w-2/6 text-left pl-1' },
                            {
                                title: empresa?.integrarCadastroClientes853 ? 'Cliente' : 'Cliente ou Provedor Externo',
                                field: empresa?.integrarCadastroClientes853 ? 'customer.nomeFantasia' : 'provedor',
                                sort: true,
                                className: 'w-3/12 pl-1 text-left border-l border-gray-300'
                            },
                            { title: 'Unidade de Medida', field: 'unidade', sort: true, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                            { title: 'Data', field: 'data', sort: true, className: 'w-1/6 pl-1 text-left border-l border-gray-300' },
                        ]}
                        LineDataPrint={(data) => {
                            return [
                                data.descricao,
                                empresa?.integrarCadastroClientes853 ? data.customer?.nomeFantasia : data.provedor,
                                data.unidade,
                                dateToString(data.data),
                            ];
                        }}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <Input name="descricao" label="Descrição" />
                                    {empresa?.integrarCadastroClientes853 === false ? (
                                        <Input name="provedor" label="Cliente ou Provedor Externo" />
                                    ) : (
                                        <DBSelectInput
                                            name="customer"
                                            label="Cliente"
                                            url="/customer"
                                            displaySelectField="nomeFantasia"
                                        />
                                    )}
                                    <GroupInput>
                                        <Input name="unidade" label="Unidade de Medida" />
                                        <DateInputBR name="data" label="Data" />
                                    </GroupInput>
                                </div>
                            );
                        }}
                        FormTabs={[
                            () => {
                                return <div>Home</div>;
                            },
                            () => {
                                return <div>Controle</div>;
                            },
                        ]}
                        onBeforeDelete={async (item) => {
                            await System.apiDelete('/griddocument/grid853-' + item._id);
                        }}
                        onRenderFormExtra={[
                            // Controle
                            (GridModes, item, GridRefresh) => {
                                return (
                                    <div>
                                        {!GridModes.insert_mode && (
                                            <div className={'m-2'}>
                                                <Grid
                                                    url={'/griddocument/grid853-' + item._id}
                                                    perms={'853'}
                                                    key={uuidv4()}
                                                    disableModal={true}
                                                    GridTitle="Controle"
                                                    GridHeaders={[
                                                        { title: 'Data', field: 'Data', sort: true, className: 'w-1/4 text-left pl-1' },
                                                        { title: 'Nota Fiscal', field: 'nota', sort: true, className: 'w-1/4 pl-1 text-left border-l border-gray-300' },
                                                        { title: 'Tipo', field: 'tipo', sort: true, className: 'w-1/4 pl-1 text-left border-l border-gray-300' },
                                                        {
                                                            title: 'Quantidade',
                                                            field: 'quantidade',
                                                            sort: false,
                                                            className: 'w-1/4 pl-1 text-left border-l border-gray-300',
                                                            totalize: true,
                                                            totalTitle: 'Estoque',
                                                        },
                                                    ]}
                                                    LineDataPrint={(data) => {
                                                        return [
                                                            dateToString(data.data),
                                                            data.nota,
                                                            data.tipo,
                                                            <div className="inline-flex text-center">
                                                                {data.tipo === 'Entrada' ? <BiPlusCircle className="w-4 h-4 mt-1" /> : <BiMinusCircle className="w-4 h-4 mt-1" />}
                                                                {data.quantidade}
                                                            </div>,
                                                        ];
                                                    }}
                                                    TotalLineDataPrint={(data, GridTotal) => {
                                                        return GridTotal.map((totalizador) => {
                                                            if (totalizador.field === 'quantidade') {
                                                                if (data.tipo === 'Entrada') totalizador.value += parseInt(data.quantidade);
                                                                else totalizador.value -= parseInt(data.quantidade);
                                                            }
                                                            return true;
                                                        });
                                                    }}
                                                    onRenderForm={(GridModes, setFieldValue, values) => {
                                                        return (
                                                            <div className="w-full">
                                                                <GroupInput>
                                                                    <DateInputBR name="data" label="Data" className={'w-1/6'} />
                                                                    <Input name="nota" label="Nota Fiscal" className={'w-1/6'} />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <SelectInput
                                                                        name="tipo"
                                                                        label="Tipo"
                                                                        className={'w-1/6'}
                                                                        onChange={(e) => {
                                                                            setFieldValue('tipo', e.target.value);
                                                                        }}
                                                                        listOptions={[{ value: 'Entrada' }, { value: 'Saida' }]}
                                                                    />
                                                                    <Input name="quantidade" label="Quantidade" className={'w-1/6'} />
                                                                </GroupInput>
                                                            </div>
                                                        );
                                                    }}
                                                    onPrepareSaveRecord={(values) => {
                                                        values.gridparent = item._id;
                                                        let newForm = new FormData();
                                                        for (let key in values) {
                                                            newForm.append(key, values[key]);
                                                        }
                                                        return newForm;
                                                    }}
                                                    validationSchema={() => {
                                                        return yup.object().shape({});
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                        ]}
                        validationSchema={yup.object().shape({
                            descricao: yup.string().required(),
                            provedor: yup.string(),
                            unidade: yup.string(),
                            data: yup.date(),
                        })}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url={`/attachment/form853`} perms="853" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
const Form853Laudos = ({ System, empresa }) => {
    const gridFotoRef = useRef(null);

    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form853"
                        perms="853"
                        title={System.getMenuTitle(853)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Gestão">
                    <Grid
                        url={'/griddocument/grid853'}
                        url_get_all={'/griddocument853laudos'}
                        perms={'853'}
                        disableModal={true}
                        clearAutoEdit={true}
                        forceReloadAfterSave={true}
                        GridTitle={'8.5.3 - Propriedade do cliente ou Provedor Externo'}
                        GridHeaders={[
                            { title: 'Descrição', field: 'descricao', sort: true, className: 'w-3/12 text-left pl-1' },
                            {
                                title: empresa?.integrarCadastroClientes853 ? 'Cliente' : 'Cliente ou Provedor Externo',
                                field: empresa?.integrarCadastroClientes853 ? 'customer.nomeFantasia' : 'provedor',
                                sort: true,
                                className: 'w-3/12 pl-1 text-left border-l border-gray-300'
                            },
                            { title: 'Unidade', field: 'unidade', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            { title: 'Data', field: 'data', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                            ...(empresa?.controleLaudos853 ? [
                                { title: 'Controle/Estoque', field: 'estoque', sort: true, className: 'w-1/12 pl-1 text-center border-l border-gray-300' },
                                {
                                    title: 'Foto',
                                    field: 'foto',
                                    filter: false,
                                    sort: false,
                                    type: 'fileview',
                                    className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                },
                                {
                                    title: 'Higienização',
                                    field: 'higienizacao',
                                    filter: false,
                                    sort: false,
                                    type: 'fileview',
                                    className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                },
                                {
                                    title: 'Estanqueidade',
                                    field: 'estanqueidade',
                                    filter: false,
                                    sort: false,
                                    type: 'fileview',
                                    className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                },
                                {
                                    title: 'Hidrostático',
                                    field: 'hidrostatico',
                                    filter: false,
                                    sort: false,
                                    type: 'fileview',
                                    className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                },
                                {
                                    title: 'Cert.Carga',
                                    field: 'carga',
                                    filter: false,
                                    sort: false,
                                    type: 'fileview',
                                    className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                },

                            ] : []),
                        ]}
                        LineDataPrint={(data) => {
                            return [
                                data.descricao,
                                empresa?.integrarCadastroClientes853 ? data.customer?.nomeFantasia : data.provedor,
                                data.unidade,
                                dateToString(data.data),
                                // controle de laudos
                                ...(empresa?.controleLaudos853 ? [
                                    String(data?.estoque),
                                    data.foto?.attachment,
                                    data.higienizacao?.attachment,
                                    data.estanqueidade?.attachment,
                                    data.hidrostatico?.attachment,
                                    data.carga?.attachment,
                                ] : [])
                            ];
                        }}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <Input name="descricao" label="Descrição" />
                                    {empresa?.integrarCadastroClientes853 === false ? (
                                        <Input name="provedor" label="Cliente ou Provedor Externo" />
                                    ) : (
                                        <DBSelectInput
                                            name="customer"
                                            label="Cliente"
                                            url="/customer"
                                            displaySelectField="nomeFantasia"
                                        />
                                    )}
                                    <GroupInput>
                                        <Input name="unidade" label="Unidade de Medida" />
                                        <DateInputBR name="data" label="Data" />
                                    </GroupInput>
                                </div>
                            );
                        }}
                        FormTabs={[
                            () => {
                                return <div>Home</div>;
                            },
                            () => {
                                return <div>Controle</div>;
                            },
                            ...(empresa?.controleLaudos853 ? [
                                () => {
                                    return <div>Fotos</div>;
                                },
                                () => {
                                    return <div>Laudo de Higienização</div>;
                                },
                                () => {
                                    return <div>Teste de Estanqueidade</div>;
                                },
                                () => {
                                    return <div>Teste Hidrostático</div>;
                                },
                                () => {
                                    return <div>Teste de Carga</div>;
                                },
                            ] : [])

                        ]}
                        onBeforeDelete={async (item) => {
                            await System.apiDelete('/griddocument/grid853-' + item._id);
                            await System.apiDelete('/griddocument/grid853-foto-' + item._id);
                            await System.apiDelete('/griddocument/grid853-higienizacao-' + item._id);
                            await System.apiDelete('/griddocument/grid853-estanqueidade-' + item._id);
                            await System.apiDelete('/griddocument/grid853-hidrostatico-' + item._id);
                            await System.apiDelete('/griddocument/grid853-carga-' + item._id);
                        }}
                        onRenderFormExtra={[
                            // Controle
                            (GridModes, item, GridRefresh) => {
                                return (
                                    <div>
                                        {!GridModes.insert_mode && (
                                            <div className={'m-2'}>
                                                <Grid
                                                    url={'/griddocument/grid853-' + item._id}
                                                    perms={'853'}
                                                    disableModal={true}
                                                    GridTitle="Controle"
                                                    GridHeaders={[
                                                        { title: 'Data', field: 'Data', sort: true, className: 'w-1/4 text-left pl-1' },
                                                        { title: 'Nota Fiscal', field: 'nota', sort: true, className: 'w-1/4 pl-1 text-left border-l border-gray-300' },
                                                        { title: 'Tipo', field: 'tipo', sort: true, className: 'w-1/4 pl-1 text-left border-l border-gray-300' },
                                                        {
                                                            title: 'Quantidade',
                                                            field: 'quantidade',
                                                            sort: false,
                                                            className: 'w-1/4 pl-1 text-left border-l border-gray-300',
                                                            totalize: true,
                                                            totalTitle: 'Estoque',
                                                        },
                                                    ]}
                                                    LineDataPrint={(data) => {
                                                        return [
                                                            dateToString(data.data),
                                                            data.nota,
                                                            data.tipo,
                                                            <div className="inline-flex text-center">
                                                                {data.tipo === 'Entrada' ? <BiPlusCircle className="w-4 h-4 mt-1" /> : <BiMinusCircle className="w-4 h-4 mt-1" />}
                                                                {data.quantidade}
                                                            </div>,
                                                        ];
                                                    }}
                                                    TotalLineDataPrint={(data, GridTotal) => {
                                                        return GridTotal.map((totalizador) => {
                                                            if (totalizador.field === 'quantidade') {
                                                                if (data.tipo === 'Entrada') totalizador.value += parseInt(data.quantidade);
                                                                else totalizador.value -= parseInt(data.quantidade);
                                                            }
                                                            return true;
                                                        });
                                                    }}
                                                    onRenderForm={(GridModes, setFieldValue, values) => {
                                                        return (
                                                            <div className="w-full">
                                                                <GroupInput>
                                                                    <DateInputBR name="data" label="Data" className={'w-1/6'} />
                                                                    <Input name="nota" label="Nota Fiscal" className={'w-1/6'} />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <SelectInput
                                                                        name="tipo"
                                                                        label="Tipo"
                                                                        className={'w-1/6'}
                                                                        onChange={(e) => {
                                                                            setFieldValue('tipo', e.target.value);
                                                                        }}
                                                                        listOptions={[{ value: 'Entrada' }, { value: 'Saida' }]}
                                                                    />
                                                                    <Input name="quantidade" label="Quantidade" className={'w-1/6'} />
                                                                </GroupInput>
                                                            </div>
                                                        );
                                                    }}
                                                    onPrepareSaveRecord={(values) => {
                                                        values.gridparent = item._id;
                                                        let newForm = new FormData();
                                                        for (let key in values) {
                                                            newForm.append(key, values[key]);
                                                        }
                                                        return newForm;
                                                    }}
                                                    validationSchema={() => {
                                                        return yup.object().shape({});
                                                    }}
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                            ...(empresa?.controleLaudos853 ? [
                                // Laudos - Fotos
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div className={'m-2'}>
                                            <Grid
                                                url={`/griddocument/grid853-foto-${item._id}`}
                                                perms={'853'}
                                                disableModal={true}
                                                forceReloadAfterSave={true}
                                                externalRef={gridFotoRef}
                                                hideIndexColumn={true}
                                                defaultSortField="numero"
                                                defaultSortOrder="desc"
                                                key={uuidv4()}
                                                GridHeaders={[
                                                    { title: 'Número', field: 'numero', sort: true, className: 'w-1/12 text-left pl-1' },
                                                    { title: 'Responsável', field: 'crew.nome', sort: true, className: 'w-7/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Data Revisão', field: 'analise', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Status Aprovação', field: 'statusaprovacao', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                    {
                                                        title: 'Anexo',
                                                        field: 'anexo',
                                                        filter: false,
                                                        sort: false,
                                                        type: 'fileview',
                                                        className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                                    },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [
                                                        data.numero,
                                                        data.crew?.nome,
                                                        dateToString(data.datarevisao),
                                                        data.statusaprovacao,
                                                        { fileid: data.attachment },
                                                    ];
                                                }}
                                                onBeforeInsertAction={(item) => {
                                                    const GridData = gridFotoRef.current.methods.GridData();
                                                    const maxNumero = Math.max(...GridData.map(item => item.numero), 0);
                                                    item.numero = (maxNumero + 1).toString();
                                                    return item;
                                                }}
                                                onPrepareSaveRecord={(values) => {
                                                    values.gridparent = item._id;
                                                    let newForm = new FormData();
                                                    for (let key in values) {
                                                        newForm.append(key, values[key]);
                                                    }
                                                    return newForm;
                                                }}
                                                onRenderForm={(GridModes, setFieldValue, values, GridRefresh) => {
                                                    return (
                                                        <div className="w-full">
                                                            <GroupInput>
                                                                <Input name="numero" label="Número" className={'w-1/4'} />
                                                                <DateInputBR name="datarevisao" label="Data Revisão" className={'inline-block'} />
                                                                <DBSelectInput
                                                                    name="responsavel"
                                                                    label="Execução"
                                                                    url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                    displaySelectField="nome"
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <SelectInput
                                                                    name="statusaprovacao"
                                                                    label="Status Aprovação"
                                                                    className={'w-3/6'}
                                                                    defaultValue={'Pendente'}
                                                                    listOptions={[{ value: 'Concluído' }, { value: 'Pendente' }]}
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <AttachmentInput
                                                                    name="attachment"
                                                                    perms="853"
                                                                    label="Anexo"
                                                                />
                                                            </GroupInput>
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    );
                                },
                                // Laudos - Higienizacao
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div className={'m-2'}>
                                            <Grid
                                                url={`/griddocument/grid853-higienizacao-${item._id}`}
                                                perms={'853'}
                                                disableModal={true}
                                                forceReloadAfterSave={true}
                                                externalRef={gridFotoRef}
                                                hideIndexColumn={true}
                                                defaultSortField="numero"
                                                defaultSortOrder="desc"
                                                key={uuidv4()}
                                                GridHeaders={[
                                                    { title: 'Número', field: 'numero', sort: true, className: 'w-1/12 text-left pl-1' },
                                                    { title: 'Responsável', field: 'crew.nome', sort: true, className: 'w-7/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Data Revisão', field: 'analise', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Status Aprovação', field: 'statusaprovacao', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                    {
                                                        title: 'Anexo',
                                                        field: 'anexo',
                                                        filter: false,
                                                        sort: false,
                                                        type: 'fileview',
                                                        className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                                    },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [
                                                        data.numero,
                                                        data.crew?.nome,
                                                        dateToString(data.datarevisao),
                                                        data.statusaprovacao,
                                                        { fileid: data.attachment },
                                                    ];
                                                }}
                                                onBeforeInsertAction={(item) => {
                                                    const GridData = gridFotoRef.current.methods.GridData();
                                                    const maxNumero = Math.max(...GridData.map(item => item.numero), 0);
                                                    item.numero = (maxNumero + 1).toString();
                                                    return item;
                                                }}
                                                onPrepareSaveRecord={(values) => {
                                                    values.gridparent = item._id;
                                                    let newForm = new FormData();
                                                    for (let key in values) {
                                                        newForm.append(key, values[key]);
                                                    }
                                                    return newForm;
                                                }}
                                                onRenderForm={(GridModes, setFieldValue, values, GridRefresh) => {
                                                    return (
                                                        <div className="w-full">
                                                            <GroupInput>
                                                                <Input name="numero" label="Número" className={'w-1/4'} />
                                                                <DateInputBR name="datarevisao" label="Data Revisão" className={'inline-block'} />
                                                                <DBSelectInput
                                                                    name="responsavel"
                                                                    label="Execução"
                                                                    url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                    displaySelectField="nome"
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <SelectInput
                                                                    name="statusaprovacao"
                                                                    label="Status Aprovação"
                                                                    className={'w-3/6'}
                                                                    defaultValue={'Pendente'}
                                                                    listOptions={[{ value: 'Concluído' }, { value: 'Pendente' }]}
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <AttachmentInput
                                                                    name="attachment"
                                                                    perms="853"
                                                                    label="Anexo"
                                                                />
                                                            </GroupInput>
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    );
                                },
                                // Laudos - Estanqueidade
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div className={'m-2'}>
                                            <Grid
                                                url={`/griddocument/grid853-estanqueidade-${item._id}`}
                                                perms={'853'}
                                                disableModal={true}
                                                forceReloadAfterSave={true}
                                                externalRef={gridFotoRef}
                                                hideIndexColumn={true}
                                                defaultSortField="numero"
                                                defaultSortOrder="desc"
                                                key={uuidv4()}
                                                GridHeaders={[
                                                    { title: 'Número', field: 'numero', sort: true, className: 'w-1/12 text-left pl-1' },
                                                    { title: 'Responsável', field: 'crew.nome', sort: true, className: 'w-7/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Data Revisão', field: 'analise', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Status Aprovação', field: 'statusaprovacao', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                    {
                                                        title: 'Anexo',
                                                        field: 'anexo',
                                                        filter: false,
                                                        sort: false,
                                                        type: 'fileview',
                                                        className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                                    },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [
                                                        data.numero,
                                                        data.crew?.nome,
                                                        dateToString(data.datarevisao),
                                                        data.statusaprovacao,
                                                        { fileid: data.attachment },
                                                    ];
                                                }}
                                                onBeforeInsertAction={(item) => {
                                                    const GridData = gridFotoRef.current.methods.GridData();
                                                    const maxNumero = Math.max(...GridData.map(item => item.numero), 0);
                                                    item.numero = (maxNumero + 1).toString();
                                                    return item;
                                                }}
                                                onPrepareSaveRecord={(values) => {
                                                    values.gridparent = item._id;
                                                    let newForm = new FormData();
                                                    for (let key in values) {
                                                        newForm.append(key, values[key]);
                                                    }
                                                    return newForm;
                                                }}
                                                onRenderForm={(GridModes, setFieldValue, values, GridRefresh) => {
                                                    return (
                                                        <div className="w-full">
                                                            <GroupInput>
                                                                <Input name="numero" label="Número" className={'w-1/4'} />
                                                                <DateInputBR name="datarevisao" label="Data Revisão" className={'inline-block'} />
                                                                <DBSelectInput
                                                                    name="responsavel"
                                                                    label="Execução"
                                                                    url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                    displaySelectField="nome"
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <SelectInput
                                                                    name="statusaprovacao"
                                                                    label="Status Aprovação"
                                                                    className={'w-3/6'}
                                                                    defaultValue={'Pendente'}
                                                                    listOptions={[{ value: 'Concluído' }, { value: 'Pendente' }]}
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <AttachmentInput
                                                                    name="attachment"
                                                                    perms="853"
                                                                    label="Anexo"
                                                                />
                                                            </GroupInput>
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    );
                                },
                                // Laudos - Hidrostático
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div className={'m-2'}>
                                            <Grid
                                                url={`/griddocument/grid853-hidrostatico-${item._id}`}
                                                perms={'853'}
                                                disableModal={true}
                                                forceReloadAfterSave={true}
                                                externalRef={gridFotoRef}
                                                hideIndexColumn={true}
                                                defaultSortField="numero"
                                                defaultSortOrder="desc"
                                                key={uuidv4()}
                                                GridHeaders={[
                                                    { title: 'Número', field: 'numero', sort: true, className: 'w-1/12 text-left pl-1' },
                                                    { title: 'Responsável', field: 'crew.nome', sort: true, className: 'w-7/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Data Revisão', field: 'analise', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Status Aprovação', field: 'statusaprovacao', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                    {
                                                        title: 'Anexo',
                                                        field: 'anexo',
                                                        filter: false,
                                                        sort: false,
                                                        type: 'fileview',
                                                        className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                                    },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [
                                                        data.numero,
                                                        data.crew?.nome,
                                                        dateToString(data.datarevisao),
                                                        data.statusaprovacao,
                                                        { fileid: data.attachment },
                                                    ];
                                                }}
                                                onBeforeInsertAction={(item) => {
                                                    const GridData = gridFotoRef.current.methods.GridData();
                                                    const maxNumero = Math.max(...GridData.map(item => item.numero), 0);
                                                    item.numero = (maxNumero + 1).toString();
                                                    return item;
                                                }}
                                                onPrepareSaveRecord={(values) => {
                                                    values.gridparent = item._id;
                                                    let newForm = new FormData();
                                                    for (let key in values) {
                                                        newForm.append(key, values[key]);
                                                    }
                                                    return newForm;
                                                }}
                                                onRenderForm={(GridModes, setFieldValue, values, GridRefresh) => {
                                                    return (
                                                        <div className="w-full">
                                                            <GroupInput>
                                                                <Input name="numero" label="Número" className={'w-1/4'} />
                                                                <DateInputBR name="datarevisao" label="Data Revisão" className={'inline-block'} />
                                                                <DBSelectInput
                                                                    name="responsavel"
                                                                    label="Execução"
                                                                    url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                    displaySelectField="nome"
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <SelectInput
                                                                    name="statusaprovacao"
                                                                    label="Status Aprovação"
                                                                    className={'w-3/6'}
                                                                    defaultValue={'Pendente'}
                                                                    listOptions={[{ value: 'Concluído' }, { value: 'Pendente' }]}
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <AttachmentInput
                                                                    name="attachment"
                                                                    perms="853"
                                                                    label="Anexo"
                                                                />
                                                            </GroupInput>
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    );
                                },
                                // Laudos - Cert.Carga
                                (GridModes, item, GridRefresh) => {
                                    return (
                                        <div className={'m-2'}>
                                            <Grid
                                                url={`/griddocument/grid853-carga-${item._id}`}
                                                perms={'853'}
                                                disableModal={true}
                                                forceReloadAfterSave={true}
                                                externalRef={gridFotoRef}
                                                hideIndexColumn={true}
                                                defaultSortField="numero"
                                                defaultSortOrder="desc"
                                                key={uuidv4()}
                                                GridHeaders={[
                                                    { title: 'Número', field: 'numero', sort: true, className: 'w-1/12 text-left pl-1' },
                                                    { title: 'Responsável', field: 'crew.nome', sort: true, className: 'w-7/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Data Revisão', field: 'analise', sort: true, className: 'w-1/12 pl-1 text-left border-l border-gray-300' },
                                                    { title: 'Status Aprovação', field: 'statusaprovacao', sort: false, className: 'w-2/12 pl-1 text-left border-l border-gray-300' },
                                                    {
                                                        title: 'Anexo',
                                                        field: 'anexo',
                                                        filter: false,
                                                        sort: false,
                                                        type: 'fileview',
                                                        className: 'w-1/12 pl-1 text-center border-l border-gray-300',
                                                    },
                                                ]}
                                                LineDataPrint={(data) => {
                                                    return [
                                                        data.numero,
                                                        data.crew?.nome,
                                                        dateToString(data.datarevisao),
                                                        data.statusaprovacao,
                                                        { fileid: data.attachment },
                                                    ];
                                                }}
                                                onBeforeInsertAction={(item) => {
                                                    const GridData = gridFotoRef.current.methods.GridData();
                                                    const maxNumero = Math.max(...GridData.map(item => item.numero), 0);
                                                    item.numero = (maxNumero + 1).toString();
                                                    return item;
                                                }}
                                                onPrepareSaveRecord={(values) => {
                                                    values.gridparent = item._id;
                                                    let newForm = new FormData();
                                                    for (let key in values) {
                                                        newForm.append(key, values[key]);
                                                    }
                                                    return newForm;
                                                }}
                                                onRenderForm={(GridModes, setFieldValue, values, GridRefresh) => {
                                                    return (
                                                        <div className="w-full">
                                                            <GroupInput>
                                                                <Input name="numero" label="Número" className={'w-1/4'} />
                                                                <DateInputBR name="datarevisao" label="Data Revisão" className={'inline-block'} />
                                                                <DBSelectInput
                                                                    name="responsavel"
                                                                    label="Execução"
                                                                    url={GridModes.insert_mode ? '/crewactive' : '/crew'}
                                                                    displaySelectField="nome"
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <SelectInput
                                                                    name="statusaprovacao"
                                                                    label="Status Aprovação"
                                                                    className={'w-3/6'}
                                                                    defaultValue={'Pendente'}
                                                                    listOptions={[{ value: 'Concluído' }, { value: 'Pendente' }]}
                                                                />
                                                            </GroupInput>
                                                            <GroupInput>
                                                                <AttachmentInput
                                                                    name="attachment"
                                                                    perms="853"
                                                                    label="Anexo"
                                                                />
                                                            </GroupInput>
                                                        </div>
                                                    );
                                                }}
                                            />
                                        </div>
                                    );
                                },
                            ] : [])
                        ]}
                        validationSchema={yup.object().shape({
                            descricao: yup.string().required(),
                            provedor: yup.string(),
                            unidade: yup.string(),
                            data: yup.date(),
                        })}
                    />
                </TabPanel>
                <TabPanel name="Anexos">
                    <GridAnexos url={`/attachment/form853`} perms="853" />
                </TabPanel>
            </TabsInput>
        </div>
    );
}


export const Form853 = () => {
    const System = useSystemContext();
    const [empresa, setEmpresa] = useState({});
    useEffect(() => {
        System.methods.getCompany().then(setEmpresa);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!empresa) return null;

    return empresa?.controleLaudos853 ? (<Form853Laudos System={System} empresa={empresa} />) : (<Form853Normal System={System} empresa={empresa} />);
}

export const Form854 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel>
                    <FormInput
                        document="/document/form854"
                        perms="854"
                        title={System.getMenuTitle(854)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel>
                    <Grid
                        url={'/griddocument/grid854'}
                        perms={'854'}
                        clearAutoEdit={true}
                        GridHeaders={[
                            { title: 'Descrição', field: 'descricao', sort: true, className: 'w-4/6 text-left pl-1' },
                            { title: 'Etapa', field: 'etapa', sort: true, className: 'w-2/6 pl-1 text-left border-l border-gray-300' },
                        ]}
                        LineDataPrint={(data) => {
                            return [data.descricao, data.etapa];
                        }}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <Input name="descricao" label="Descrição" />
                                    <Input name="etapa" label="Etapa" />
                                    <Input name="situacao" label="Situação" />
                                    <Input name="controle" label="Controle" />
                                </div>
                            );
                        }}
                        validationSchema={yup.object().shape({
                            descricao: yup.string().required(),
                            etapa: yup.string(),
                            situacao: yup.string(),
                            controle: yup.string(),
                        })}
                    />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form855 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form855"
                perms="855"
                title={System.getMenuTitle(855)}
                initialValues={{
                    conteudo: '',
                }}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form856 = () => {
    const System = useSystemContext();
    return (
        <div>
            <FormInput
                document="/document/form856"
                perms="856"
                title={System.getMenuTitle(856)}
                initialValues={{
                    conteudo: '',
                }}
                validationSchema={yup.object().shape({
                    conteudo: yup.string(),
                })}
                onRenderFields={() => {
                    return (
                        <div className="w-full">
                            <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                        </div>
                    );
                }}
            />
        </div>
    );
};
export const Form86 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Gestão</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form86"
                        perms="86"
                        title={System.getMenuTitle(86)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel name="Liberação de P&S">
                    <Grid
                        url={'/griddocument/grid86'}
                        perms={'86'}
                        clearAutoEdit={true}
                        GridHeaders={[
                            { title: 'Etapa', field: 'etapa', sort: true, className: 'w-1/2 text-left pl-1' },
                            { title: 'Processo', field: 'processo', sort: true, className: 'w-1/2 pl-1 text-left border-l border-gray-300' },
                        ]}
                        LineDataPrint={(data) => {
                            return [data.etapa, data.processo];
                        }}
                        GridTitle={'8.6 - Liberação de P&S'}
                        onRenderForm={(GridModes, SetFieldValue, values) => {
                            return (
                                <div>
                                    <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                        <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                    </div>
                                    <Input name="etapa" label="Etapa" />
                                    <Input name="processo" label="Processo" />
                                    <Input name="criterio" label="Critério de Aceitação" />
                                    <Input name="docid" label="ID" />
                                </div>
                            );
                        }}
                        validationSchema={yup.object().shape({
                            etapa: yup.string().required(),
                            processo: yup.string(),
                            criterio: yup.string(),
                            docid: yup.string(),
                        })}
                    />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
export const Form87 = () => {
    const System = useSystemContext();
    return (
        <div className="mx-2">
            <TabsInput>
                <TabList>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <div>🔷</div>
                        </div>
                    </Tab>
                    <Tab>
                        <div className="inline-flex justify-center">
                            <span>Anexos</span>
                        </div>
                    </Tab>
                </TabList>
                <TabPanel name="Principal">
                    <FormInput
                        document="/document/form87"
                        perms="87"
                        title={System.getMenuTitle(87)}
                        initialValues={{
                            conteudo: '',
                        }}
                        validationSchema={yup.object().shape({
                            conteudo: yup.string(),
                        })}
                        onRenderFields={() => {
                            return (
                                <div className="w-full">
                                    <TextInput name="conteudo" label="Conteúdo" className="w-full" rows="8" />
                                </div>
                            );
                        }}
                    />
                </TabPanel>
                <TabPanel>
                    <GridAnexos url="/attachment/form87" perms="87" />
                </TabPanel>
            </TabsInput>
        </div>
    );
};
